// @generated by protoc-gen-es v2.15.0 with parameter "target=ts"
// @generated from file tempus/v1/tempus.proto (package tempus.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptySchema, FieldMask, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_field_mask, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file tempus/v1/tempus.proto.
 */
export const file_tempus_v1_tempus: GenFile = /*@__PURE__*/
  fileDesc("ChZ0ZW1wdXMvdjEvdGVtcHVzLnByb3RvEgl0ZW1wdXMudjEimQEKCENhdGVnb3J5EgoKAmlkGAEgASgFEgwKBG5hbWUYAiABKAkSEwoLZGVzY3JpcHRpb24YAyABKAkSLgoKY3JlYXRlZF9hdBgEIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASLgoKdXBkYXRlZF9hdBgFIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXAioAEKA1RhZxIKCgJpZBgBIAEoBRIMCgRuYW1lGAIgASgJEi4KCmNyZWF0ZWRfYXQYAyABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEjsKF2xhc3Rfc2Vzc2lvbl9zdGFydGVkX2F0GAUgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEoECAQQBVIMY2F0ZWdvcnlfaWRzIt0ECghFeGVyY2lzZRIKCgJpZBgBIAEoBRIMCgRuYW1lGAIgASgJEhMKC2Rlc2NyaXB0aW9uGAMgASgJEi4KCmNyZWF0ZWRfYXQYBCABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEi4KCnVwZGF0ZWRfYXQYBSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEg8KB3RhZ19pZHMYBiADKAUSIAoTZGVmYXVsdF9jYXRlZ29yeV9pZBgHIAEoBUgAiAEBEigKBmltYWdlcxgIIAMoCzIYLnRlbXB1cy52MS5FeGVyY2lzZUltYWdlEiYKBWxpbmtzGAkgAygLMhcudGVtcHVzLnYxLkV4ZXJjaXNlTGluaxIxCg1sYXN0X3ByYWN0aWNlGAogASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIRCglsYXN0X2JwbXMYCyADKAUSEgoKbGFzdF9ub3RlcxgMIAEoCRIVCg1ub3RhdGlvbl9qc29uGA0gASgJEh8KEnBhcmVudF9leGVyY2lzZV9pZBgOIAEoBUgBiAEBEicKCnZhcmlhdGlvbnMYDyADKAsyEy50ZW1wdXMudjEuRXhlcmNpc2USFwoKdGFyZ2V0X2JwbRgQIAEoBUgCiAEBEhAKCGFyY2hpdmVkGBEgASgIEhkKEWxhc3RfY2F0ZWdvcnlfaWRzGBIgAygFQhYKFF9kZWZhdWx0X2NhdGVnb3J5X2lkQhUKE19wYXJlbnRfZXhlcmNpc2VfaWRCDQoLX3RhcmdldF9icG0i2gEKDUV4ZXJjaXNlSW1hZ2USCgoCaWQYASABKAUSEwoLZXhlcmNpc2VfaWQYAiABKAUSEgoKaW1hZ2VfZGF0YRgDIAEoDBIQCghmaWxlbmFtZRgEIAEoCRIRCgltaW1lX3R5cGUYBSABKAkSEwoLZGVzY3JpcHRpb24YBiABKAkSLgoKY3JlYXRlZF9hdBgHIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASGQoMdmFyaWF0aW9uX2lkGAggASgFSACIAQFCDwoNX3ZhcmlhdGlvbl9pZCKBAQoMRXhlcmNpc2VMaW5rEgoKAmlkGAEgASgFEhMKC2V4ZXJjaXNlX2lkGAIgASgFEgsKA3VybBgDIAEoCRITCgtkZXNjcmlwdGlvbhgEIAEoCRIuCgpjcmVhdGVkX2F0GAUgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcCLMAwoPUHJhY3RpY2VTZXNzaW9uEgoKAmlkGAEgASgFEi4KCnN0YXJ0X3RpbWUYAiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEiwKCGVuZF90aW1lGAMgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBINCgVub3RlcxgEIAEoCRIuCgpjcmVhdGVkX2F0GAUgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIuCgp1cGRhdGVkX2F0GAYgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBItCglleGVyY2lzZXMYByADKAsyGi50ZW1wdXMudjEuRXhlcmNpc2VIaXN0b3J5Eg4KBmFjdGl2ZRgIIAEoCBIOCgZwYXVzZWQYCSABKAgSLQoJcGF1c2VkX2F0GAogASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIcChR0b3RhbF9wYXVzZWRfc2Vjb25kcxgLIAEoBRIWCg5leGVyY2lzZV9jb3VudBgMIAEoBRIaCg1zb3VyY2VfdGFnX2lkGA0gASgFSACIAQFCEAoOX3NvdXJjZV90YWdfaWQivgIKD0V4ZXJjaXNlSGlzdG9yeRIKCgJpZBgBIAEoBRITCgtleGVyY2lzZV9pZBgCIAEoBRIuCgpzdGFydF90aW1lGAMgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIsCghlbmRfdGltZRgEIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASDAoEYnBtcxgFIAMoBRINCgVub3RlcxgHIAEoCRIOCgZyYXRpbmcYCCABKAUSJQoIZXhlcmNpc2UYCSABKAsyEy50ZW1wdXMudjEuRXhlcmNpc2USEgoKc2Vzc2lvbl9pZBgKIAEoBRIYChBkdXJhdGlvbl9zZWNvbmRzGAsgASgFEhQKDGNhdGVnb3J5X2lkcxgMIAMoBUoECAYQB1IOdGltZV9zaWduYXR1cmUiOgoVQ3JlYXRlQ2F0ZWdvcnlSZXF1ZXN0EgwKBG5hbWUYASABKAkSEwoLZGVzY3JpcHRpb24YAiABKAkiIAoSR2V0Q2F0ZWdvcnlSZXF1ZXN0EgoKAmlkGAEgASgFIj4KFUxpc3RDYXRlZ29yaWVzUmVxdWVzdBIRCglwYWdlX3NpemUYASABKAUSEgoKcGFnZV90b2tlbhgCIAEoCSJvChZMaXN0Q2F0ZWdvcmllc1Jlc3BvbnNlEicKCmNhdGVnb3JpZXMYASADKAsyEy50ZW1wdXMudjEuQ2F0ZWdvcnkSFwoPbmV4dF9wYWdlX3Rva2VuGAIgASgJEhMKC3RvdGFsX2NvdW50GAMgASgFInsKFVVwZGF0ZUNhdGVnb3J5UmVxdWVzdBIKCgJpZBgBIAEoBRIlCghjYXRlZ29yeRgCIAEoCzITLnRlbXB1cy52MS5DYXRlZ29yeRIvCgt1cGRhdGVfbWFzaxgDIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5GaWVsZE1hc2siIwoVRGVsZXRlQ2F0ZWdvcnlSZXF1ZXN0EgoKAmlkGAEgASgFIjQKEENyZWF0ZVRhZ1JlcXVlc3QSDAoEbmFtZRgBIAEoCUoECAIQA1IMY2F0ZWdvcnlfaWRzIhsKDUdldFRhZ1JlcXVlc3QSCgoCaWQYASABKAUiSwoPTGlzdFRhZ3NSZXF1ZXN0EhEKCXBhZ2Vfc2l6ZRgBIAEoBRISCgpwYWdlX3Rva2VuGAIgASgJSgQIAxAEUgtjYXRlZ29yeV9pZCJeChBMaXN0VGFnc1Jlc3BvbnNlEhwKBHRhZ3MYASADKAsyDi50ZW1wdXMudjEuVGFnEhcKD25leHRfcGFnZV90b2tlbhgCIAEoCRITCgt0b3RhbF9jb3VudBgDIAEoBSJsChBVcGRhdGVUYWdSZXF1ZXN0EgoKAmlkGAEgASgFEhsKA3RhZxgCIAEoCzIOLnRlbXB1cy52MS5UYWcSLwoLdXBkYXRlX21hc2sYAyABKAsyGi5nb29nbGUucHJvdG9idWYuRmllbGRNYXNrIh4KEERlbGV0ZVRhZ1JlcXVlc3QSCgoCaWQYASABKAUilgIKFUNyZWF0ZUV4ZXJjaXNlUmVxdWVzdBIMCgRuYW1lGAEgASgJEhMKC2Rlc2NyaXB0aW9uGAIgASgJEg8KB3RhZ19pZHMYAyADKAUSKAoGaW1hZ2VzGAQgAygLMhgudGVtcHVzLnYxLkV4ZXJjaXNlSW1hZ2USJgoFbGlua3MYBSADKAsyFy50ZW1wdXMudjEuRXhlcmNpc2VMaW5rEhUKDW5vdGF0aW9uX2pzb24YBiABKAkSIAoTZGVmYXVsdF9jYXRlZ29yeV9pZBgHIAEoBUgAiAEBEhcKCnRhcmdldF9icG0YCCABKAVIAYgBAUIWChRfZGVmYXVsdF9jYXRlZ29yeV9pZEINCgtfdGFyZ2V0X2JwbSIgChJHZXRFeGVyY2lzZVJlcXVlc3QSCgoCaWQYASABKAUifAoUTGlzdEV4ZXJjaXNlc1JlcXVlc3QSEQoJcGFnZV9zaXplGAEgASgFEhIKCnBhZ2VfdG9rZW4YAiABKAkSEwoLY2F0ZWdvcnlfaWQYAyABKAUSDgoGdGFnX2lkGAQgASgFEhgKEGluY2x1ZGVfYXJjaGl2ZWQYBSABKAgibQoVTGlzdEV4ZXJjaXNlc1Jlc3BvbnNlEiYKCWV4ZXJjaXNlcxgBIAMoCzITLnRlbXB1cy52MS5FeGVyY2lzZRIXCg9uZXh0X3BhZ2VfdG9rZW4YAiABKAkSEwoLdG90YWxfY291bnQYAyABKAUiewoVVXBkYXRlRXhlcmNpc2VSZXF1ZXN0EgoKAmlkGAEgASgFEiUKCGV4ZXJjaXNlGAIgASgLMhMudGVtcHVzLnYxLkV4ZXJjaXNlEi8KC3VwZGF0ZV9tYXNrGAMgASgLMhouZ29vZ2xlLnByb3RvYnVmLkZpZWxkTWFzayIjChVEZWxldGVFeGVyY2lzZVJlcXVlc3QSCgoCaWQYASABKAUifAoXQWRkRXhlcmNpc2VJbWFnZVJlcXVlc3QSEwoLZXhlcmNpc2VfaWQYASABKAUSEgoKaW1hZ2VfZGF0YRgCIAEoDBIQCghmaWxlbmFtZRgDIAEoCRIRCgltaW1lX3R5cGUYBCABKAkSEwoLZGVzY3JpcHRpb24YBSABKAkiQAoXR2V0RXhlcmNpc2VJbWFnZVJlcXVlc3QSEwoLZXhlcmNpc2VfaWQYASABKAUSEAoIaW1hZ2VfaWQYAiABKAUiggEKGlVwZGF0ZUV4ZXJjaXNlSW1hZ2VSZXF1ZXN0EgoKAmlkGAEgASgFEicKBWltYWdlGAIgASgLMhgudGVtcHVzLnYxLkV4ZXJjaXNlSW1hZ2USLwoLdXBkYXRlX21hc2sYAyABKAsyGi5nb29nbGUucHJvdG9idWYuRmllbGRNYXNrIigKGkRlbGV0ZUV4ZXJjaXNlSW1hZ2VSZXF1ZXN0EgoKAmlkGAEgASgFIk8KFkFkZEV4ZXJjaXNlTGlua1JlcXVlc3QSEwoLZXhlcmNpc2VfaWQYASABKAUSCwoDdXJsGAIgASgJEhMKC2Rlc2NyaXB0aW9uGAMgASgJIicKGURlbGV0ZUV4ZXJjaXNlTGlua1JlcXVlc3QSCgoCaWQYASABKAUilgEKFkNyZWF0ZVZhcmlhdGlvblJlcXVlc3QSGgoScGFyZW50X2V4ZXJjaXNlX2lkGAEgASgFEgwKBG5hbWUYAiABKAkSEwoLZGVzY3JpcHRpb24YAyABKAkSFQoNbm90YXRpb25fanNvbhgEIAEoCRIXCgp0YXJnZXRfYnBtGAUgASgFSACIAQFCDQoLX3RhcmdldF9icG0iMwoVTGlzdFZhcmlhdGlvbnNSZXF1ZXN0EhoKEnBhcmVudF9leGVyY2lzZV9pZBgBIAEoBSJBChZMaXN0VmFyaWF0aW9uc1Jlc3BvbnNlEicKCnZhcmlhdGlvbnMYASADKAsyEy50ZW1wdXMudjEuRXhlcmNpc2UiuQEKHENyZWF0ZVByYWN0aWNlU2Vzc2lvblJlcXVlc3QSLgoKc3RhcnRfdGltZRgBIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASLAoIZW5kX3RpbWUYAiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEg0KBW5vdGVzGAMgASgJEhoKDXNvdXJjZV90YWdfaWQYBCABKAVIAIgBAUIQCg5fc291cmNlX3RhZ19pZCInChlHZXRQcmFjdGljZVNlc3Npb25SZXF1ZXN0EgoKAmlkGAEgASgFIscBChtMaXN0UHJhY3RpY2VTZXNzaW9uc1JlcXVlc3QSEQoJcGFnZV9zaXplGAEgASgFEhIKCnBhZ2VfdG9rZW4YAiABKAkSLgoKc3RhcnRfZGF0ZRgDIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASLAoIZW5kX2RhdGUYBCABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEhMKC2V4ZXJjaXNlX2lkGAUgASgFEg4KBmFjdGl2ZRgGIAEoCCJ6ChxMaXN0UHJhY3RpY2VTZXNzaW9uc1Jlc3BvbnNlEiwKCHNlc3Npb25zGAEgAygLMhoudGVtcHVzLnYxLlByYWN0aWNlU2Vzc2lvbhIXCg9uZXh0X3BhZ2VfdG9rZW4YAiABKAkSEwoLdG90YWxfY291bnQYAyABKAUiiAEKHFVwZGF0ZVByYWN0aWNlU2Vzc2lvblJlcXVlc3QSCgoCaWQYASABKAUSKwoHc2Vzc2lvbhgCIAEoCzIaLnRlbXB1cy52MS5QcmFjdGljZVNlc3Npb24SLwoLdXBkYXRlX21hc2sYAyABKAsyGi5nb29nbGUucHJvdG9idWYuRmllbGRNYXNrIioKHERlbGV0ZVByYWN0aWNlU2Vzc2lvblJlcXVlc3QSCgoCaWQYASABKAUimAIKHENyZWF0ZUV4ZXJjaXNlSGlzdG9yeVJlcXVlc3QSEwoLZXhlcmNpc2VfaWQYASABKAUSLgoKc3RhcnRfdGltZRgCIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASLAoIZW5kX3RpbWUYAyABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEgwKBGJwbXMYBCADKAUSDQoFbm90ZXMYBiABKAkSDgoGcmF0aW5nGAcgASgFEhIKCnNlc3Npb25faWQYCCABKAUSGAoQZHVyYXRpb25fc2Vjb25kcxgJIAEoBRIUCgxjYXRlZ29yeV9pZHMYCiADKAVKBAgFEAZSDnRpbWVfc2lnbmF0dXJlIicKGUdldEV4ZXJjaXNlSGlzdG9yeVJlcXVlc3QSCgoCaWQYASABKAUiygEKGkxpc3RFeGVyY2lzZUhpc3RvcnlSZXF1ZXN0EhEKCXBhZ2Vfc2l6ZRgBIAEoBRISCgpwYWdlX3Rva2VuGAIgASgJEhMKC2V4ZXJjaXNlX2lkGAMgASgFEi4KCnN0YXJ0X2RhdGUYBCABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEiwKCGVuZF9kYXRlGAUgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBISCgpzZXNzaW9uX2lkGAYgASgFIoABChtMaXN0RXhlcmNpc2VIaXN0b3J5UmVzcG9uc2USMwoPaGlzdG9yeV9lbnRyaWVzGAEgAygLMhoudGVtcHVzLnYxLkV4ZXJjaXNlSGlzdG9yeRIXCg9uZXh0X3BhZ2VfdG9rZW4YAiABKAkSEwoLdG90YWxfY291bnQYAyABKAUiiAEKHFVwZGF0ZUV4ZXJjaXNlSGlzdG9yeVJlcXVlc3QSCgoCaWQYASABKAUSKwoHaGlzdG9yeRgCIAEoCzIaLnRlbXB1cy52MS5FeGVyY2lzZUhpc3RvcnkSLwoLdXBkYXRlX21hc2sYAyABKAsyGi5nb29nbGUucHJvdG9idWYuRmllbGRNYXNrIioKHERlbGV0ZUV4ZXJjaXNlSGlzdG9yeVJlcXVlc3QSCgoCaWQYASABKAUipwEKF0dldEV4ZXJjaXNlU3RhdHNSZXF1ZXN0EhMKC2V4ZXJjaXNlX2lkGAEgASgFEi4KCnN0YXJ0X2RhdGUYAiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEiwKCGVuZF9kYXRlGAMgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIZChF0el9vZmZzZXRfbWludXRlcxgEIAEoBSL2AQoNRXhlcmNpc2VTdGF0cxITCgtleGVyY2lzZV9pZBgBIAEoBRIVCg1leGVyY2lzZV9uYW1lGAIgASgJEhYKDnByYWN0aWNlX2NvdW50GAMgASgFEicKH3RvdGFsX3ByYWN0aWNlX2R1cmF0aW9uX3NlY29uZHMYBCABKAUSEgoKYXZnX3JhdGluZxgFIAEoARIPCgdtYXhfYnBtGAYgASgFEg8KB21pbl9icG0YByABKAUSDwoHYXZnX2JwbRgIIAEoARIxCgxicG1fcHJvZ3Jlc3MYCSADKAsyGy50ZW1wdXMudjEuQnBtUHJvZ3Jlc3NQb2ludCJJChBCcG1Qcm9ncmVzc1BvaW50EigKBGRhdGUYASABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEgsKA2JwbRgCIAEoBSKnAQoXR2V0UHJhY3RpY2VTdGF0c1JlcXVlc3QSLgoKc3RhcnRfZGF0ZRgBIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASLAoIZW5kX2RhdGUYAiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEhMKC2NhdGVnb3J5X2lkGAMgASgFEhkKEXR6X29mZnNldF9taW51dGVzGAQgASgFIq8CCg1QcmFjdGljZVN0YXRzEhYKDnRvdGFsX3Nlc3Npb25zGAEgASgFEh4KFnRvdGFsX2R1cmF0aW9uX3NlY29uZHMYAiABKAUSJAocYXZnX3Nlc3Npb25fZHVyYXRpb25fc2Vjb25kcxgDIAEoARJCChVleGVyY2lzZV9kaXN0cmlidXRpb24YBCADKAsyIy50ZW1wdXMudjEuRXhlcmNpc2VUaW1lRGlzdHJpYnV0aW9uEkIKFWNhdGVnb3J5X2Rpc3RyaWJ1dGlvbhgFIAMoCzIjLnRlbXB1cy52MS5DYXRlZ29yeVRpbWVEaXN0cmlidXRpb24SOAoScHJhY3RpY2VfZnJlcXVlbmN5GAYgAygLMhwudGVtcHVzLnYxLlByYWN0aWNlVGltZVBvaW50InQKGEV4ZXJjaXNlVGltZURpc3RyaWJ1dGlvbhITCgtleGVyY2lzZV9pZBgBIAEoBRIVCg1leGVyY2lzZV9uYW1lGAIgASgJEhgKEGR1cmF0aW9uX3NlY29uZHMYAyABKAUSEgoKcGVyY2VudGFnZRgEIAEoASKuAQoYQ2F0ZWdvcnlUaW1lRGlzdHJpYnV0aW9uEhMKC2NhdGVnb3J5X2lkGAEgASgFEhUKDWNhdGVnb3J5X25hbWUYAiABKAkSGAoQZHVyYXRpb25fc2Vjb25kcxgDIAEoBRISCgpwZXJjZW50YWdlGAQgASgBEjgKEnByYWN0aWNlX2ZyZXF1ZW5jeRgFIAMoCzIcLnRlbXB1cy52MS5QcmFjdGljZVRpbWVQb2ludCJXChFQcmFjdGljZVRpbWVQb2ludBIoCgRkYXRlGAEgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIYChBkdXJhdGlvbl9zZWNvbmRzGAIgASgFImAKDk5ld0JyZWVkU3lzdGVtEgoKAmlkGAEgASgFEg4KBm51bWJlchgCIAEoBRIMCgRuYW1lGAMgASgJEhMKC2Rlc2NyaXB0aW9uGAQgASgJEg8KB3NlY3Rpb24YBSABKAkicAoSTmV3QnJlZWRNZWxvZHlQYWdlEgoKAmlkGAEgASgFEg0KBWxhYmVsGAIgASgJEhIKCnNvcnRfb3JkZXIYAyABKAUSKwoIbWVsb2RpZXMYBCADKAsyGS50ZW1wdXMudjEuTmV3QnJlZWRNZWxvZHkiPQoOTmV3QnJlZWRNZWxvZHkSCgoCaWQYASABKAUSDwoHcGFnZV9pZBgCIAEoBRIOCgZudW1iZXIYAyABKAUisQMKFU5ld0JyZWVkUHJhY3RpY2VFbnRyeRIKCgJpZBgBIAEoBRISCgpzZXNzaW9uX2lkGAIgASgFEhEKCXN5c3RlbV9pZBgDIAEoBRIPCgdwYWdlX2lkGAQgASgFEhMKC2dyYW51bGFyaXR5GAUgASgJEi4KCnN0YXJ0X3RpbWUYBiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEiwKCGVuZF90aW1lGAcgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIMCgRicG1zGAggAygFEg0KBW5vdGVzGAkgASgJEg4KBnJhdGluZxgKIAEoBRIYChBkdXJhdGlvbl9zZWNvbmRzGAsgASgFEi4KCmNyZWF0ZWRfYXQYDCABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEhIKCm1lbG9keV9pZHMYDSADKAUSKQoGc3lzdGVtGA4gASgLMhkudGVtcHVzLnYxLk5ld0JyZWVkU3lzdGVtEisKBHBhZ2UYDyABKAsyHS50ZW1wdXMudjEuTmV3QnJlZWRNZWxvZHlQYWdlIvYBChROZXdCcmVlZFByb2dyZXNzQ2VsbBIRCglzeXN0ZW1faWQYASABKAUSFQoNc3lzdGVtX251bWJlchgCIAEoBRIPCgdwYWdlX2lkGAMgASgFEhIKCnBhZ2VfbGFiZWwYBCABKAkSFgoOcHJhY3RpY2VfY291bnQYBSABKAUSMgoObGFzdF9wcmFjdGljZWQYBiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEg8KB21heF9icG0YByABKAUSEgoKYXZnX3JhdGluZxgIIAEoARIeChZ0b3RhbF9kdXJhdGlvbl9zZWNvbmRzGAkgASgFIrEBChZOZXdCcmVlZFN5c3RlbVByb2dyZXNzEikKBnN5c3RlbRgBIAEoCzIZLnRlbXB1cy52MS5OZXdCcmVlZFN5c3RlbRIuCgVwYWdlcxgCIAMoCzIfLnRlbXB1cy52MS5OZXdCcmVlZFBhZ2VQcm9ncmVzcxIcChR0b3RhbF9wcmFjdGljZV9jb3VudBgDIAEoBRIeChZ0b3RhbF9kdXJhdGlvbl9zZWNvbmRzGAQgASgFItUBChROZXdCcmVlZFBhZ2VQcm9ncmVzcxIrCgRwYWdlGAEgASgLMh0udGVtcHVzLnYxLk5ld0JyZWVkTWVsb2R5UGFnZRIWCg5wcmFjdGljZV9jb3VudBgCIAEoBRIyCg5sYXN0X3ByYWN0aWNlZBgDIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASDwoHbWF4X2JwbRgEIAEoBRIzCghtZWxvZGllcxgFIAMoCzIhLnRlbXB1cy52MS5OZXdCcmVlZE1lbG9keVByb2dyZXNzIo8BChZOZXdCcmVlZE1lbG9keVByb2dyZXNzEikKBm1lbG9keRgBIAEoCzIZLnRlbXB1cy52MS5OZXdCcmVlZE1lbG9keRIWCg5wcmFjdGljZV9jb3VudBgCIAEoBRIyCg5sYXN0X3ByYWN0aWNlZBgDIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXAiFAoSTGlzdFN5c3RlbXNSZXF1ZXN0IkEKE0xpc3RTeXN0ZW1zUmVzcG9uc2USKgoHc3lzdGVtcxgBIAMoCzIZLnRlbXB1cy52MS5OZXdCcmVlZFN5c3RlbSIYChZMaXN0TWVsb2R5UGFnZXNSZXF1ZXN0IkcKF0xpc3RNZWxvZHlQYWdlc1Jlc3BvbnNlEiwKBXBhZ2VzGAEgAygLMh0udGVtcHVzLnYxLk5ld0JyZWVkTWVsb2R5UGFnZSKiAgoaQ3JlYXRlUHJhY3RpY2VFbnRyeVJlcXVlc3QSEgoKc2Vzc2lvbl9pZBgBIAEoBRIRCglzeXN0ZW1faWQYAiABKAUSDwoHcGFnZV9pZBgDIAEoBRITCgtncmFudWxhcml0eRgEIAEoCRIuCgpzdGFydF90aW1lGAUgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIsCghlbmRfdGltZRgGIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASDAoEYnBtcxgHIAMoBRINCgVub3RlcxgIIAEoCRIOCgZyYXRpbmcYCSABKAUSGAoQZHVyYXRpb25fc2Vjb25kcxgKIAEoBRISCgptZWxvZHlfaWRzGAsgAygFIiUKF0dldFByYWN0aWNlRW50cnlSZXF1ZXN0EgoKAmlkGAEgASgFInsKGkxpc3RQcmFjdGljZUVudHJpZXNSZXF1ZXN0EhIKCnNlc3Npb25faWQYASABKAUSEQoJc3lzdGVtX2lkGAIgASgFEg8KB3BhZ2VfaWQYAyABKAUSEQoJcGFnZV9zaXplGAQgASgFEhIKCnBhZ2VfdG9rZW4YBSABKAkifgobTGlzdFByYWN0aWNlRW50cmllc1Jlc3BvbnNlEjEKB2VudHJpZXMYASADKAsyIC50ZW1wdXMudjEuTmV3QnJlZWRQcmFjdGljZUVudHJ5EhcKD25leHRfcGFnZV90b2tlbhgCIAEoCRITCgt0b3RhbF9jb3VudBgDIAEoBSKKAQoaVXBkYXRlUHJhY3RpY2VFbnRyeVJlcXVlc3QSCgoCaWQYASABKAUSLwoFZW50cnkYAiABKAsyIC50ZW1wdXMudjEuTmV3QnJlZWRQcmFjdGljZUVudHJ5Ei8KC3VwZGF0ZV9tYXNrGAMgASgLMhouZ29vZ2xlLnByb3RvYnVmLkZpZWxkTWFzayIoChpEZWxldGVQcmFjdGljZUVudHJ5UmVxdWVzdBIKCgJpZBgBIAEoBSJwChBHZXRNYXRyaXhSZXF1ZXN0Ei4KCnN0YXJ0X2RhdGUYASABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEiwKCGVuZF9kYXRlGAIgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcCKdAQoRR2V0TWF0cml4UmVzcG9uc2USLgoFY2VsbHMYASADKAsyHy50ZW1wdXMudjEuTmV3QnJlZWRQcm9ncmVzc0NlbGwSKgoHc3lzdGVtcxgCIAMoCzIZLnRlbXB1cy52MS5OZXdCcmVlZFN5c3RlbRIsCgVwYWdlcxgDIAMoCzIdLnRlbXB1cy52MS5OZXdCcmVlZE1lbG9keVBhZ2UiiwEKGEdldFN5c3RlbVByb2dyZXNzUmVxdWVzdBIRCglzeXN0ZW1faWQYASABKAUSLgoKc3RhcnRfZGF0ZRgCIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASLAoIZW5kX2RhdGUYAyABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wIooBChlHZXRTeXN0ZW1Qcm9ncmVzc1Jlc3BvbnNlEjMKCHByb2dyZXNzGAEgASgLMiEudGVtcHVzLnYxLk5ld0JyZWVkU3lzdGVtUHJvZ3Jlc3MSOAoOcmVjZW50X2VudHJpZXMYAiADKAsyIC50ZW1wdXMudjEuTmV3QnJlZWRQcmFjdGljZUVudHJ5IiUKB1NldHRpbmcSCwoDa2V5GAEgASgJEg0KBXZhbHVlGAIgASgJIiAKEUdldFNldHRpbmdSZXF1ZXN0EgsKA2tleRgBIAEoCSI5ChJHZXRTZXR0aW5nUmVzcG9uc2USIwoHc2V0dGluZxgBIAEoCzISLnRlbXB1cy52MS5TZXR0aW5nIi8KEVNldFNldHRpbmdSZXF1ZXN0EgsKA2tleRgBIAEoCRINCgV2YWx1ZRgCIAEoCSI5ChJTZXRTZXR0aW5nUmVzcG9uc2USIwoHc2V0dGluZxgBIAEoCzISLnRlbXB1cy52MS5TZXR0aW5nIhUKE0xpc3RTZXR0aW5nc1JlcXVlc3QiPAoUTGlzdFNldHRpbmdzUmVzcG9uc2USJAoIc2V0dGluZ3MYASADKAsyEi50ZW1wdXMudjEuU2V0dGluZyLnAgoHU3JzQ2FyZBITCgtleGVyY2lzZV9pZBgBIAEoBRITCgtlYXNlX2ZhY3RvchgCIAEoARIVCg1pbnRlcnZhbF9kYXlzGAMgASgBEhMKC3JlcGV0aXRpb25zGAQgASgFEiwKCGR1ZV9kYXRlGAUgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIxCg1sYXN0X3Jldmlld2VkGAYgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIUCgxtYXN0ZXJlZF9icG0YByABKAUSEAoIYnBtX3N0ZXAYCSABKAUSLgoKY3JlYXRlZF9hdBgKIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASJQoIZXhlcmNpc2UYCyABKAsyEy50ZW1wdXMudjEuRXhlcmNpc2USFAoMZGF5c19vdmVyZHVlGAwgASgFSgQICBAJUgp0YXJnZXRfYnBtImgKFUVucm9sbEV4ZXJjaXNlUmVxdWVzdBITCgtleGVyY2lzZV9pZBgBIAEoBRISCgp0YXJnZXRfYnBtGAIgASgFEhQKDG1hc3RlcmVkX2JwbRgDIAEoBRIQCghicG1fc3RlcBgEIAEoBSIuChdVbmVucm9sbEV4ZXJjaXNlUmVxdWVzdBITCgtleGVyY2lzZV9pZBgBIAEoBSIlCg5HZXRDYXJkUmVxdWVzdBITCgtleGVyY2lzZV9pZBgBIAEoBSI+ChBMaXN0Q2FyZHNSZXF1ZXN0EhAKCGR1ZV9vbmx5GAEgASgIEhgKEGluY2x1ZGVfYXJjaGl2ZWQYAiABKAgiNgoRTGlzdENhcmRzUmVzcG9uc2USIQoFY2FyZHMYASADKAsyEi50ZW1wdXMudjEuU3JzQ2FyZCImChVMaXN0RHVlUmV2aWV3c1JlcXVlc3QSDQoFbGltaXQYASABKAUiTgoWTGlzdER1ZVJldmlld3NSZXNwb25zZRIhCgVjYXJkcxgBIAMoCzISLnRlbXB1cy52MS5TcnNDYXJkEhEKCXRvdGFsX2R1ZRgCIAEoBSJ7ChFVcGRhdGVDYXJkUmVxdWVzdBITCgtleGVyY2lzZV9pZBgBIAEoBRIgCgRjYXJkGAIgASgLMhIudGVtcHVzLnYxLlNyc0NhcmQSLwoLdXBkYXRlX21hc2sYAyABKAsyGi5nb29nbGUucHJvdG9idWYuRmllbGRNYXNrIusBCgtSZXZpZXdTdGF0ZRITCgtlYXNlX2ZhY3RvchgBIAEoARIVCg1pbnRlcnZhbF9kYXlzGAIgASgBEhMKC3JlcGV0aXRpb25zGAMgASgFEiwKCGR1ZV9kYXRlGAQgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIxCg1sYXN0X3Jldmlld2VkGAUgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIUCgxtYXN0ZXJlZF9icG0YBiABKAUSEgoKdGFyZ2V0X2JwbRgHIAEoBRIQCghicG1fc3RlcBgIIAEoBSK7AgoLUmV2aWV3RXZlbnQSCgoCaWQYASABKAMSEwoLZXhlcmNpc2VfaWQYAiABKAUSEgoKZXZlbnRfdHlwZRgDIAEoCRIvCgtvY2N1cnJlZF9hdBgEIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASDAoEYnBtcxgFIAMoBRIOCgZyYXRpbmcYBiABKAUSDwoHcXVhbGl0eRgHIAEoBRIPCgdzdW1tYXJ5GAggASgJEi4KDnByZXZpb3VzX3N0YXRlGAkgASgLMhYudGVtcHVzLnYxLlJldmlld1N0YXRlEi8KD3Jlc3VsdGluZ19zdGF0ZRgKIAEoCzIWLnRlbXB1cy52MS5SZXZpZXdTdGF0ZRIlCghleGVyY2lzZRgLIAEoCzITLnRlbXB1cy52MS5FeGVyY2lzZSI9ChdMaXN0UmV2aWV3RXZlbnRzUmVxdWVzdBITCgtleGVyY2lzZV9pZBgBIAEoBRINCgVsaW1pdBgCIAEoBSJCChhMaXN0UmV2aWV3RXZlbnRzUmVzcG9uc2USJgoGZXZlbnRzGAEgAygLMhYudGVtcHVzLnYxLlJldmlld0V2ZW50Il8KBFVzZXISCgoCaWQYASABKAUSDQoFZW1haWwYAiABKAkSDAoEbmFtZRgDIAEoCRIuCgpjcmVhdGVkX2F0GAQgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcCJTCg1TaWdudXBSZXF1ZXN0Eg0KBWVtYWlsGAEgASgJEhAKCHBhc3N3b3JkGAIgASgJEgwKBG5hbWUYAyABKAkSEwoLaW52aXRlX2NvZGUYBCABKAkiLwoMTG9naW5SZXF1ZXN0Eg0KBWVtYWlsGAEgASgJEhAKCHBhc3N3b3JkGAIgASgJIg8KDUxvZ291dFJlcXVlc3QiCwoJTWVSZXF1ZXN0MokDCg9DYXRlZ29yeVNlcnZpY2USRwoOQ3JlYXRlQ2F0ZWdvcnkSIC50ZW1wdXMudjEuQ3JlYXRlQ2F0ZWdvcnlSZXF1ZXN0GhMudGVtcHVzLnYxLkNhdGVnb3J5EkEKC0dldENhdGVnb3J5Eh0udGVtcHVzLnYxLkdldENhdGVnb3J5UmVxdWVzdBoTLnRlbXB1cy52MS5DYXRlZ29yeRJVCg5MaXN0Q2F0ZWdvcmllcxIgLnRlbXB1cy52MS5MaXN0Q2F0ZWdvcmllc1JlcXVlc3QaIS50ZW1wdXMudjEuTGlzdENhdGVnb3JpZXNSZXNwb25zZRJHCg5VcGRhdGVDYXRlZ29yeRIgLnRlbXB1cy52MS5VcGRhdGVDYXRlZ29yeVJlcXVlc3QaEy50ZW1wdXMudjEuQ2F0ZWdvcnkSSgoORGVsZXRlQ2F0ZWdvcnkSIC50ZW1wdXMudjEuRGVsZXRlQ2F0ZWdvcnlSZXF1ZXN0GhYuZ29vZ2xlLnByb3RvYnVmLkVtcHR5MrsCCgpUYWdTZXJ2aWNlEjgKCUNyZWF0ZVRhZxIbLnRlbXB1cy52MS5DcmVhdGVUYWdSZXF1ZXN0Gg4udGVtcHVzLnYxLlRhZxIyCgZHZXRUYWcSGC50ZW1wdXMudjEuR2V0VGFnUmVxdWVzdBoOLnRlbXB1cy52MS5UYWcSQwoITGlzdFRhZ3MSGi50ZW1wdXMudjEuTGlzdFRhZ3NSZXF1ZXN0GhsudGVtcHVzLnYxLkxpc3RUYWdzUmVzcG9uc2USOAoJVXBkYXRlVGFnEhsudGVtcHVzLnYxLlVwZGF0ZVRhZ1JlcXVlc3QaDi50ZW1wdXMudjEuVGFnEkAKCURlbGV0ZVRhZxIbLnRlbXB1cy52MS5EZWxldGVUYWdSZXF1ZXN0GhYuZ29vZ2xlLnByb3RvYnVmLkVtcHR5Mu8ICg9FeGVyY2lzZVNlcnZpY2USRwoOQ3JlYXRlRXhlcmNpc2USIC50ZW1wdXMudjEuQ3JlYXRlRXhlcmNpc2VSZXF1ZXN0GhMudGVtcHVzLnYxLkV4ZXJjaXNlEkEKC0dldEV4ZXJjaXNlEh0udGVtcHVzLnYxLkdldEV4ZXJjaXNlUmVxdWVzdBoTLnRlbXB1cy52MS5FeGVyY2lzZRJSCg1MaXN0RXhlcmNpc2VzEh8udGVtcHVzLnYxLkxpc3RFeGVyY2lzZXNSZXF1ZXN0GiAudGVtcHVzLnYxLkxpc3RFeGVyY2lzZXNSZXNwb25zZRJHCg5VcGRhdGVFeGVyY2lzZRIgLnRlbXB1cy52MS5VcGRhdGVFeGVyY2lzZVJlcXVlc3QaEy50ZW1wdXMudjEuRXhlcmNpc2USSgoORGVsZXRlRXhlcmNpc2USIC50ZW1wdXMudjEuRGVsZXRlRXhlcmNpc2VSZXF1ZXN0GhYuZ29vZ2xlLnByb3RvYnVmLkVtcHR5ElAKEEFkZEV4ZXJjaXNlSW1hZ2USIi50ZW1wdXMudjEuQWRkRXhlcmNpc2VJbWFnZVJlcXVlc3QaGC50ZW1wdXMudjEuRXhlcmNpc2VJbWFnZRJQChBHZXRFeGVyY2lzZUltYWdlEiIudGVtcHVzLnYxLkdldEV4ZXJjaXNlSW1hZ2VSZXF1ZXN0GhgudGVtcHVzLnYxLkV4ZXJjaXNlSW1hZ2USVgoTVXBkYXRlRXhlcmNpc2VJbWFnZRIlLnRlbXB1cy52MS5VcGRhdGVFeGVyY2lzZUltYWdlUmVxdWVzdBoYLnRlbXB1cy52MS5FeGVyY2lzZUltYWdlElQKE0RlbGV0ZUV4ZXJjaXNlSW1hZ2USJS50ZW1wdXMudjEuRGVsZXRlRXhlcmNpc2VJbWFnZVJlcXVlc3QaFi5nb29nbGUucHJvdG9idWYuRW1wdHkSTQoPQWRkRXhlcmNpc2VMaW5rEiEudGVtcHVzLnYxLkFkZEV4ZXJjaXNlTGlua1JlcXVlc3QaFy50ZW1wdXMudjEuRXhlcmNpc2VMaW5rElIKEkRlbGV0ZUV4ZXJjaXNlTGluaxIkLnRlbXB1cy52MS5EZWxldGVFeGVyY2lzZUxpbmtSZXF1ZXN0GhYuZ29vZ2xlLnByb3RvYnVmLkVtcHR5ElAKEEdldEV4ZXJjaXNlU3RhdHMSIi50ZW1wdXMudjEuR2V0RXhlcmNpc2VTdGF0c1JlcXVlc3QaGC50ZW1wdXMudjEuRXhlcmNpc2VTdGF0cxJJCg9DcmVhdGVWYXJpYXRpb24SIS50ZW1wdXMudjEuQ3JlYXRlVmFyaWF0aW9uUmVxdWVzdBoTLnRlbXB1cy52MS5FeGVyY2lzZRJVCg5MaXN0VmFyaWF0aW9ucxIgLnRlbXB1cy52MS5MaXN0VmFyaWF0aW9uc1JlcXVlc3QaIS50ZW1wdXMudjEuTGlzdFZhcmlhdGlvbnNSZXNwb25zZTLBBAoWUHJhY3RpY2VTZXNzaW9uU2VydmljZRJcChVDcmVhdGVQcmFjdGljZVNlc3Npb24SJy50ZW1wdXMudjEuQ3JlYXRlUHJhY3RpY2VTZXNzaW9uUmVxdWVzdBoaLnRlbXB1cy52MS5QcmFjdGljZVNlc3Npb24SVgoSR2V0UHJhY3RpY2VTZXNzaW9uEiQudGVtcHVzLnYxLkdldFByYWN0aWNlU2Vzc2lvblJlcXVlc3QaGi50ZW1wdXMudjEuUHJhY3RpY2VTZXNzaW9uEmcKFExpc3RQcmFjdGljZVNlc3Npb25zEiYudGVtcHVzLnYxLkxpc3RQcmFjdGljZVNlc3Npb25zUmVxdWVzdBonLnRlbXB1cy52MS5MaXN0UHJhY3RpY2VTZXNzaW9uc1Jlc3BvbnNlElwKFVVwZGF0ZVByYWN0aWNlU2Vzc2lvbhInLnRlbXB1cy52MS5VcGRhdGVQcmFjdGljZVNlc3Npb25SZXF1ZXN0GhoudGVtcHVzLnYxLlByYWN0aWNlU2Vzc2lvbhJYChVEZWxldGVQcmFjdGljZVNlc3Npb24SJy50ZW1wdXMudjEuRGVsZXRlUHJhY3RpY2VTZXNzaW9uUmVxdWVzdBoWLmdvb2dsZS5wcm90b2J1Zi5FbXB0eRJQChBHZXRQcmFjdGljZVN0YXRzEiIudGVtcHVzLnYxLkdldFByYWN0aWNlU3RhdHNSZXF1ZXN0GhgudGVtcHVzLnYxLlByYWN0aWNlU3RhdHMy7AMKFkV4ZXJjaXNlSGlzdG9yeVNlcnZpY2USXAoVQ3JlYXRlRXhlcmNpc2VIaXN0b3J5EicudGVtcHVzLnYxLkNyZWF0ZUV4ZXJjaXNlSGlzdG9yeVJlcXVlc3QaGi50ZW1wdXMudjEuRXhlcmNpc2VIaXN0b3J5ElYKEkdldEV4ZXJjaXNlSGlzdG9yeRIkLnRlbXB1cy52MS5HZXRFeGVyY2lzZUhpc3RvcnlSZXF1ZXN0GhoudGVtcHVzLnYxLkV4ZXJjaXNlSGlzdG9yeRJkChNMaXN0RXhlcmNpc2VIaXN0b3J5EiUudGVtcHVzLnYxLkxpc3RFeGVyY2lzZUhpc3RvcnlSZXF1ZXN0GiYudGVtcHVzLnYxLkxpc3RFeGVyY2lzZUhpc3RvcnlSZXNwb25zZRJcChVVcGRhdGVFeGVyY2lzZUhpc3RvcnkSJy50ZW1wdXMudjEuVXBkYXRlRXhlcmNpc2VIaXN0b3J5UmVxdWVzdBoaLnRlbXB1cy52MS5FeGVyY2lzZUhpc3RvcnkSWAoVRGVsZXRlRXhlcmNpc2VIaXN0b3J5EicudGVtcHVzLnYxLkRlbGV0ZUV4ZXJjaXNlSGlzdG9yeVJlcXVlc3QaFi5nb29nbGUucHJvdG9idWYuRW1wdHkytwYKD05ld0JyZWVkU2VydmljZRJMCgtMaXN0U3lzdGVtcxIdLnRlbXB1cy52MS5MaXN0U3lzdGVtc1JlcXVlc3QaHi50ZW1wdXMudjEuTGlzdFN5c3RlbXNSZXNwb25zZRJYCg9MaXN0TWVsb2R5UGFnZXMSIS50ZW1wdXMudjEuTGlzdE1lbG9keVBhZ2VzUmVxdWVzdBoiLnRlbXB1cy52MS5MaXN0TWVsb2R5UGFnZXNSZXNwb25zZRJeChNDcmVhdGVQcmFjdGljZUVudHJ5EiUudGVtcHVzLnYxLkNyZWF0ZVByYWN0aWNlRW50cnlSZXF1ZXN0GiAudGVtcHVzLnYxLk5ld0JyZWVkUHJhY3RpY2VFbnRyeRJYChBHZXRQcmFjdGljZUVudHJ5EiIudGVtcHVzLnYxLkdldFByYWN0aWNlRW50cnlSZXF1ZXN0GiAudGVtcHVzLnYxLk5ld0JyZWVkUHJhY3RpY2VFbnRyeRJkChNMaXN0UHJhY3RpY2VFbnRyaWVzEiUudGVtcHVzLnYxLkxpc3RQcmFjdGljZUVudHJpZXNSZXF1ZXN0GiYudGVtcHVzLnYxLkxpc3RQcmFjdGljZUVudHJpZXNSZXNwb25zZRJeChNVcGRhdGVQcmFjdGljZUVudHJ5EiUudGVtcHVzLnYxLlVwZGF0ZVByYWN0aWNlRW50cnlSZXF1ZXN0GiAudGVtcHVzLnYxLk5ld0JyZWVkUHJhY3RpY2VFbnRyeRJUChNEZWxldGVQcmFjdGljZUVudHJ5EiUudGVtcHVzLnYxLkRlbGV0ZVByYWN0aWNlRW50cnlSZXF1ZXN0GhYuZ29vZ2xlLnByb3RvYnVmLkVtcHR5EkYKCUdldE1hdHJpeBIbLnRlbXB1cy52MS5HZXRNYXRyaXhSZXF1ZXN0GhwudGVtcHVzLnYxLkdldE1hdHJpeFJlc3BvbnNlEl4KEUdldFN5c3RlbVByb2dyZXNzEiMudGVtcHVzLnYxLkdldFN5c3RlbVByb2dyZXNzUmVxdWVzdBokLnRlbXB1cy52MS5HZXRTeXN0ZW1Qcm9ncmVzc1Jlc3BvbnNlMvgBCg9TZXR0aW5nc1NlcnZpY2USSQoKR2V0U2V0dGluZxIcLnRlbXB1cy52MS5HZXRTZXR0aW5nUmVxdWVzdBodLnRlbXB1cy52MS5HZXRTZXR0aW5nUmVzcG9uc2USSQoKU2V0U2V0dGluZxIcLnRlbXB1cy52MS5TZXRTZXR0aW5nUmVxdWVzdBodLnRlbXB1cy52MS5TZXRTZXR0aW5nUmVzcG9uc2USTwoMTGlzdFNldHRpbmdzEh4udGVtcHVzLnYxLkxpc3RTZXR0aW5nc1JlcXVlc3QaHy50ZW1wdXMudjEuTGlzdFNldHRpbmdzUmVzcG9uc2UymgQKClNyc1NlcnZpY2USRgoORW5yb2xsRXhlcmNpc2USIC50ZW1wdXMudjEuRW5yb2xsRXhlcmNpc2VSZXF1ZXN0GhIudGVtcHVzLnYxLlNyc0NhcmQSTgoQVW5lbnJvbGxFeGVyY2lzZRIiLnRlbXB1cy52MS5VbmVucm9sbEV4ZXJjaXNlUmVxdWVzdBoWLmdvb2dsZS5wcm90b2J1Zi5FbXB0eRI4CgdHZXRDYXJkEhkudGVtcHVzLnYxLkdldENhcmRSZXF1ZXN0GhIudGVtcHVzLnYxLlNyc0NhcmQSRgoJTGlzdENhcmRzEhsudGVtcHVzLnYxLkxpc3RDYXJkc1JlcXVlc3QaHC50ZW1wdXMudjEuTGlzdENhcmRzUmVzcG9uc2USVQoOTGlzdER1ZVJldmlld3MSIC50ZW1wdXMudjEuTGlzdER1ZVJldmlld3NSZXF1ZXN0GiEudGVtcHVzLnYxLkxpc3REdWVSZXZpZXdzUmVzcG9uc2USPgoKVXBkYXRlQ2FyZBIcLnRlbXB1cy52MS5VcGRhdGVDYXJkUmVxdWVzdBoSLnRlbXB1cy52MS5TcnNDYXJkElsKEExpc3RSZXZpZXdFdmVudHMSIi50ZW1wdXMudjEuTGlzdFJldmlld0V2ZW50c1JlcXVlc3QaIy50ZW1wdXMudjEuTGlzdFJldmlld0V2ZW50c1Jlc3BvbnNlMt4BCgtBdXRoU2VydmljZRIzCgZTaWdudXASGC50ZW1wdXMudjEuU2lnbnVwUmVxdWVzdBoPLnRlbXB1cy52MS5Vc2VyEjEKBUxvZ2luEhcudGVtcHVzLnYxLkxvZ2luUmVxdWVzdBoPLnRlbXB1cy52MS5Vc2VyEjoKBkxvZ291dBIYLnRlbXB1cy52MS5Mb2dvdXRSZXF1ZXN0GhYuZ29vZ2xlLnByb3RvYnVmLkVtcHR5EisKAk1lEhQudGVtcHVzLnYxLk1lUmVxdWVzdBoPLnRlbXB1cy52MS5Vc2VyQpoBCg1jb20udGVtcHVzLnYxQgtUZW1wdXNQcm90b1ABWjdnaXRodWIuY29tL1phY2gtSm9obnNvbi90ZW1wdXMvcHJvdG8vdGVtcHVzL3YxO3RlbXB1c3YxogIDVFhYqgIJVGVtcHVzLlYxygIJVGVtcHVzXFYx4gIVVGVtcHVzXFYxXEdQQk1ldGFkYXRh6gIKVGVtcHVzOjpWMWIGcHJvdG8z", [file_google_protobuf_timestamp, file_google_protobuf_empty, file_google_protobuf_field_mask]);

/**
 * Category represents a drumming category
 *
 * @generated from message tempus.v1.Category
 */
export type Category = Message<"tempus.v1.Category"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */
  updatedAt?: Timestamp | undefined;
};

/**
 * Describes the message tempus.v1.Category.
 * Use `create(CategorySchema)` to create a new message.
 */
export const CategorySchema: GenMessage<Category> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 0);

/**
 * Tag represents a tag used for categorizing exercises
 *
 * @generated from message tempus.v1.Tag
 */
export type Tag = Message<"tempus.v1.Tag"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 3;
   */
  createdAt?: Timestamp | undefined;

  /**
   * Latest session explicitly started from this tag; derived, read-only.
   *
   * @generated from field: google.protobuf.Timestamp last_session_started_at = 5;
   */
  lastSessionStartedAt?: Timestamp | undefined;
};

/**
 * Describes the message tempus.v1.Tag.
 * Use `create(TagSchema)` to create a new message.
 */
export const TagSchema: GenMessage<Tag> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 1);

/**
 * Exercise represents a drumming exercise
 *
 * @generated from message tempus.v1.Exercise
 */
export type Exercise = Message<"tempus.v1.Exercise"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */
  updatedAt?: Timestamp | undefined;

  /**
   * Related tag IDs
   *
   * @generated from field: repeated int32 tag_ids = 6;
   */
  tagIds: number[];

  /**
   * Optional default category for practice time
   *
   * @generated from field: optional int32 default_category_id = 7;
   */
  defaultCategoryId?: number | undefined;

  /**
   * @generated from field: repeated tempus.v1.ExerciseImage images = 8;
   */
  images: ExerciseImage[];

  /**
   * @generated from field: repeated tempus.v1.ExerciseLink links = 9;
   */
  links: ExerciseLink[];

  /**
   * @generated from field: google.protobuf.Timestamp last_practice = 10;
   */
  lastPractice?: Timestamp | undefined;

  /**
   * @generated from field: repeated int32 last_bpms = 11;
   */
  lastBpms: number[];

  /**
   * @generated from field: string last_notes = 12;
   */
  lastNotes: string;

  /**
   * JSON-encoded drum notation
   *
   * @generated from field: string notation_json = 13;
   */
  notationJson: string;

  /**
   * If set, this is a variation of another exercise
   *
   * @generated from field: optional int32 parent_exercise_id = 14;
   */
  parentExerciseId?: number | undefined;

  /**
   * Child variations (populated on GetExercise for parent)
   *
   * @generated from field: repeated tempus.v1.Exercise variations = 15;
   */
  variations: Exercise[];

  /**
   * Optional target/working tempo (climbs as Review mastery advances)
   *
   * @generated from field: optional int32 target_bpm = 16;
   */
  targetBpm?: number | undefined;

  /**
   * When true, hidden from lists/filters/pickers but history still counts
   *
   * @generated from field: bool archived = 17;
   */
  archived: boolean;

  /**
   * Categories used in the most recent practice
   *
   * @generated from field: repeated int32 last_category_ids = 18;
   */
  lastCategoryIds: number[];
};

/**
 * Describes the message tempus.v1.Exercise.
 * Use `create(ExerciseSchema)` to create a new message.
 */
export const ExerciseSchema: GenMessage<Exercise> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 2);

/**
 * ExerciseImage represents an image associated with an exercise
 *
 * @generated from message tempus.v1.ExerciseImage
 */
export type ExerciseImage = Message<"tempus.v1.ExerciseImage"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: int32 exercise_id = 2;
   */
  exerciseId: number;

  /**
   * @generated from field: bytes image_data = 3;
   */
  imageData: Uint8Array;

  /**
   * @generated from field: string filename = 4;
   */
  filename: string;

  /**
   * @generated from field: string mime_type = 5;
   */
  mimeType: string;

  /**
   * Free-form annotation text
   *
   * @generated from field: string description = 6;
   */
  description: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp | undefined;

  /**
   * Optional: ties this image to a variation of the exercise. The image still
   * belongs to exercise_id (the parent) but is associated with this variation.
   *
   * @generated from field: optional int32 variation_id = 8;
   */
  variationId?: number | undefined;
};

/**
 * Describes the message tempus.v1.ExerciseImage.
 * Use `create(ExerciseImageSchema)` to create a new message.
 */
export const ExerciseImageSchema: GenMessage<ExerciseImage> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 3);

/**
 * ExerciseLink represents an external link for an exercise
 *
 * @generated from message tempus.v1.ExerciseLink
 */
export type ExerciseLink = Message<"tempus.v1.ExerciseLink"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: int32 exercise_id = 2;
   */
  exerciseId: number;

  /**
   * @generated from field: string url = 3;
   */
  url: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp | undefined;
};

/**
 * Describes the message tempus.v1.ExerciseLink.
 * Use `create(ExerciseLinkSchema)` to create a new message.
 */
export const ExerciseLinkSchema: GenMessage<ExerciseLink> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 4);

/**
 * PracticeSession represents a drumming practice session
 *
 * @generated from message tempus.v1.PracticeSession
 */
export type PracticeSession = Message<"tempus.v1.PracticeSession"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: google.protobuf.Timestamp start_time = 2;
   */
  startTime?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp end_time = 3;
   */
  endTime?: Timestamp | undefined;

  /**
   * @generated from field: string notes = 4;
   */
  notes: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp | undefined;

  /**
   * @generated from field: repeated tempus.v1.ExerciseHistory exercises = 7;
   */
  exercises: ExerciseHistory[];

  /**
   * @generated from field: bool active = 8;
   */
  active: boolean;

  /**
   * Whether session is currently paused
   *
   * @generated from field: bool paused = 9;
   */
  paused: boolean;

  /**
   * When session was paused (null if not paused)
   *
   * @generated from field: google.protobuf.Timestamp paused_at = 10;
   */
  pausedAt?: Timestamp | undefined;

  /**
   * Cumulative paused time
   *
   * @generated from field: int32 total_paused_seconds = 11;
   */
  totalPausedSeconds: number;

  /**
   * Number of exercises in this session
   *
   * @generated from field: int32 exercise_count = 12;
   */
  exerciseCount: number;

  /**
   * Tag used to start this session; immutable.
   *
   * @generated from field: optional int32 source_tag_id = 13;
   */
  sourceTagId?: number | undefined;
};

/**
 * Describes the message tempus.v1.PracticeSession.
 * Use `create(PracticeSessionSchema)` to create a new message.
 */
export const PracticeSessionSchema: GenMessage<PracticeSession> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 5);

/**
 * ExerciseHistory represents a historical record of exercise performance
 *
 * @generated from message tempus.v1.ExerciseHistory
 */
export type ExerciseHistory = Message<"tempus.v1.ExerciseHistory"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: int32 exercise_id = 2;
   */
  exerciseId: number;

  /**
   * @generated from field: google.protobuf.Timestamp start_time = 3;
   */
  startTime?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp end_time = 4;
   */
  endTime?: Timestamp | undefined;

  /**
   * @generated from field: repeated int32 bpms = 5;
   */
  bpms: number[];

  /**
   * @generated from field: string notes = 7;
   */
  notes: string;

  /**
   * User rating (1-5)
   *
   * @generated from field: int32 rating = 8;
   */
  rating: number;

  /**
   * Full exercise details
   *
   * @generated from field: tempus.v1.Exercise exercise = 9;
   */
  exercise?: Exercise | undefined;

  /**
   * @generated from field: int32 session_id = 10;
   */
  sessionId: number;

  /**
   * Optional manual duration override
   *
   * @generated from field: int32 duration_seconds = 11;
   */
  durationSeconds: number;

  /**
   * Categories selected at practice time
   *
   * @generated from field: repeated int32 category_ids = 12;
   */
  categoryIds: number[];
};

/**
 * Describes the message tempus.v1.ExerciseHistory.
 * Use `create(ExerciseHistorySchema)` to create a new message.
 */
export const ExerciseHistorySchema: GenMessage<ExerciseHistory> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 6);

/**
 * CreateCategoryRequest is used to create a new category
 *
 * @generated from message tempus.v1.CreateCategoryRequest
 */
export type CreateCategoryRequest = Message<"tempus.v1.CreateCategoryRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;
};

/**
 * Describes the message tempus.v1.CreateCategoryRequest.
 * Use `create(CreateCategoryRequestSchema)` to create a new message.
 */
export const CreateCategoryRequestSchema: GenMessage<CreateCategoryRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 7);

/**
 * GetCategoryRequest is used to retrieve a specific category
 *
 * @generated from message tempus.v1.GetCategoryRequest
 */
export type GetCategoryRequest = Message<"tempus.v1.GetCategoryRequest"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;
};

/**
 * Describes the message tempus.v1.GetCategoryRequest.
 * Use `create(GetCategoryRequestSchema)` to create a new message.
 */
export const GetCategoryRequestSchema: GenMessage<GetCategoryRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 8);

/**
 * ListCategoriesRequest is used to list categories with pagination
 *
 * @generated from message tempus.v1.ListCategoriesRequest
 */
export type ListCategoriesRequest = Message<"tempus.v1.ListCategoriesRequest"> & {
  /**
   * @generated from field: int32 page_size = 1;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 2;
   */
  pageToken: string;
};

/**
 * Describes the message tempus.v1.ListCategoriesRequest.
 * Use `create(ListCategoriesRequestSchema)` to create a new message.
 */
export const ListCategoriesRequestSchema: GenMessage<ListCategoriesRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 9);

/**
 * ListCategoriesResponse contains a list of categories and pagination info
 *
 * @generated from message tempus.v1.ListCategoriesResponse
 */
export type ListCategoriesResponse = Message<"tempus.v1.ListCategoriesResponse"> & {
  /**
   * @generated from field: repeated tempus.v1.Category categories = 1;
   */
  categories: Category[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * @generated from field: int32 total_count = 3;
   */
  totalCount: number;
};

/**
 * Describes the message tempus.v1.ListCategoriesResponse.
 * Use `create(ListCategoriesResponseSchema)` to create a new message.
 */
export const ListCategoriesResponseSchema: GenMessage<ListCategoriesResponse> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 10);

/**
 * UpdateCategoryRequest is used to update a category
 *
 * @generated from message tempus.v1.UpdateCategoryRequest
 */
export type UpdateCategoryRequest = Message<"tempus.v1.UpdateCategoryRequest"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: tempus.v1.Category category = 2;
   */
  category?: Category | undefined;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 3;
   */
  updateMask?: FieldMask | undefined;
};

/**
 * Describes the message tempus.v1.UpdateCategoryRequest.
 * Use `create(UpdateCategoryRequestSchema)` to create a new message.
 */
export const UpdateCategoryRequestSchema: GenMessage<UpdateCategoryRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 11);

/**
 * DeleteCategoryRequest is used to delete a category
 *
 * @generated from message tempus.v1.DeleteCategoryRequest
 */
export type DeleteCategoryRequest = Message<"tempus.v1.DeleteCategoryRequest"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;
};

/**
 * Describes the message tempus.v1.DeleteCategoryRequest.
 * Use `create(DeleteCategoryRequestSchema)` to create a new message.
 */
export const DeleteCategoryRequestSchema: GenMessage<DeleteCategoryRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 12);

/**
 * CreateTagRequest is used to create a new tag
 *
 * @generated from message tempus.v1.CreateTagRequest
 */
export type CreateTagRequest = Message<"tempus.v1.CreateTagRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message tempus.v1.CreateTagRequest.
 * Use `create(CreateTagRequestSchema)` to create a new message.
 */
export const CreateTagRequestSchema: GenMessage<CreateTagRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 13);

/**
 * GetTagRequest is used to retrieve a specific tag
 *
 * @generated from message tempus.v1.GetTagRequest
 */
export type GetTagRequest = Message<"tempus.v1.GetTagRequest"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;
};

/**
 * Describes the message tempus.v1.GetTagRequest.
 * Use `create(GetTagRequestSchema)` to create a new message.
 */
export const GetTagRequestSchema: GenMessage<GetTagRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 14);

/**
 * ListTagsRequest is used to list tags with pagination
 *
 * @generated from message tempus.v1.ListTagsRequest
 */
export type ListTagsRequest = Message<"tempus.v1.ListTagsRequest"> & {
  /**
   * @generated from field: int32 page_size = 1;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 2;
   */
  pageToken: string;
};

/**
 * Describes the message tempus.v1.ListTagsRequest.
 * Use `create(ListTagsRequestSchema)` to create a new message.
 */
export const ListTagsRequestSchema: GenMessage<ListTagsRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 15);

/**
 * ListTagsResponse contains a list of tags and pagination info
 *
 * @generated from message tempus.v1.ListTagsResponse
 */
export type ListTagsResponse = Message<"tempus.v1.ListTagsResponse"> & {
  /**
   * @generated from field: repeated tempus.v1.Tag tags = 1;
   */
  tags: Tag[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * @generated from field: int32 total_count = 3;
   */
  totalCount: number;
};

/**
 * Describes the message tempus.v1.ListTagsResponse.
 * Use `create(ListTagsResponseSchema)` to create a new message.
 */
export const ListTagsResponseSchema: GenMessage<ListTagsResponse> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 16);

/**
 * UpdateTagRequest is used to update a tag
 *
 * @generated from message tempus.v1.UpdateTagRequest
 */
export type UpdateTagRequest = Message<"tempus.v1.UpdateTagRequest"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: tempus.v1.Tag tag = 2;
   */
  tag?: Tag | undefined;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 3;
   */
  updateMask?: FieldMask | undefined;
};

/**
 * Describes the message tempus.v1.UpdateTagRequest.
 * Use `create(UpdateTagRequestSchema)` to create a new message.
 */
export const UpdateTagRequestSchema: GenMessage<UpdateTagRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 17);

/**
 * DeleteTagRequest is used to delete a tag
 *
 * @generated from message tempus.v1.DeleteTagRequest
 */
export type DeleteTagRequest = Message<"tempus.v1.DeleteTagRequest"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;
};

/**
 * Describes the message tempus.v1.DeleteTagRequest.
 * Use `create(DeleteTagRequestSchema)` to create a new message.
 */
export const DeleteTagRequestSchema: GenMessage<DeleteTagRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 18);

/**
 * CreateExerciseRequest is used to create a new exercise
 *
 * @generated from message tempus.v1.CreateExerciseRequest
 */
export type CreateExerciseRequest = Message<"tempus.v1.CreateExerciseRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: repeated int32 tag_ids = 3;
   */
  tagIds: number[];

  /**
   * @generated from field: repeated tempus.v1.ExerciseImage images = 4;
   */
  images: ExerciseImage[];

  /**
   * @generated from field: repeated tempus.v1.ExerciseLink links = 5;
   */
  links: ExerciseLink[];

  /**
   * JSON-encoded drum notation
   *
   * @generated from field: string notation_json = 6;
   */
  notationJson: string;

  /**
   * Optional default category
   *
   * @generated from field: optional int32 default_category_id = 7;
   */
  defaultCategoryId?: number | undefined;

  /**
   * Optional target/working tempo
   *
   * @generated from field: optional int32 target_bpm = 8;
   */
  targetBpm?: number | undefined;
};

/**
 * Describes the message tempus.v1.CreateExerciseRequest.
 * Use `create(CreateExerciseRequestSchema)` to create a new message.
 */
export const CreateExerciseRequestSchema: GenMessage<CreateExerciseRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 19);

/**
 * GetExerciseRequest is used to retrieve a specific exercise
 *
 * @generated from message tempus.v1.GetExerciseRequest
 */
export type GetExerciseRequest = Message<"tempus.v1.GetExerciseRequest"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;
};

/**
 * Describes the message tempus.v1.GetExerciseRequest.
 * Use `create(GetExerciseRequestSchema)` to create a new message.
 */
export const GetExerciseRequestSchema: GenMessage<GetExerciseRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 20);

/**
 * ListExercisesRequest is used to list exercises with pagination and filters
 *
 * @generated from message tempus.v1.ListExercisesRequest
 */
export type ListExercisesRequest = Message<"tempus.v1.ListExercisesRequest"> & {
  /**
   * @generated from field: int32 page_size = 1;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 2;
   */
  pageToken: string;

  /**
   * Optional: filter by category
   *
   * @generated from field: int32 category_id = 3;
   */
  categoryId: number;

  /**
   * Optional: filter by tag
   *
   * @generated from field: int32 tag_id = 4;
   */
  tagId: number;

  /**
   * When true, archived exercises are included (default: excluded)
   *
   * @generated from field: bool include_archived = 5;
   */
  includeArchived: boolean;
};

/**
 * Describes the message tempus.v1.ListExercisesRequest.
 * Use `create(ListExercisesRequestSchema)` to create a new message.
 */
export const ListExercisesRequestSchema: GenMessage<ListExercisesRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 21);

/**
 * ListExercisesResponse contains a list of exercises and pagination info
 *
 * @generated from message tempus.v1.ListExercisesResponse
 */
export type ListExercisesResponse = Message<"tempus.v1.ListExercisesResponse"> & {
  /**
   * @generated from field: repeated tempus.v1.Exercise exercises = 1;
   */
  exercises: Exercise[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * @generated from field: int32 total_count = 3;
   */
  totalCount: number;
};

/**
 * Describes the message tempus.v1.ListExercisesResponse.
 * Use `create(ListExercisesResponseSchema)` to create a new message.
 */
export const ListExercisesResponseSchema: GenMessage<ListExercisesResponse> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 22);

/**
 * UpdateExerciseRequest is used to update an exercise
 *
 * @generated from message tempus.v1.UpdateExerciseRequest
 */
export type UpdateExerciseRequest = Message<"tempus.v1.UpdateExerciseRequest"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: tempus.v1.Exercise exercise = 2;
   */
  exercise?: Exercise | undefined;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 3;
   */
  updateMask?: FieldMask | undefined;
};

/**
 * Describes the message tempus.v1.UpdateExerciseRequest.
 * Use `create(UpdateExerciseRequestSchema)` to create a new message.
 */
export const UpdateExerciseRequestSchema: GenMessage<UpdateExerciseRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 23);

/**
 * DeleteExerciseRequest is used to delete an exercise
 *
 * @generated from message tempus.v1.DeleteExerciseRequest
 */
export type DeleteExerciseRequest = Message<"tempus.v1.DeleteExerciseRequest"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;
};

/**
 * Describes the message tempus.v1.DeleteExerciseRequest.
 * Use `create(DeleteExerciseRequestSchema)` to create a new message.
 */
export const DeleteExerciseRequestSchema: GenMessage<DeleteExerciseRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 24);

/**
 * AddExerciseImageRequest is used to add an image to an exercise
 *
 * @generated from message tempus.v1.AddExerciseImageRequest
 */
export type AddExerciseImageRequest = Message<"tempus.v1.AddExerciseImageRequest"> & {
  /**
   * @generated from field: int32 exercise_id = 1;
   */
  exerciseId: number;

  /**
   * @generated from field: bytes image_data = 2;
   */
  imageData: Uint8Array;

  /**
   * @generated from field: string filename = 3;
   */
  filename: string;

  /**
   * @generated from field: string mime_type = 4;
   */
  mimeType: string;

  /**
   * @generated from field: string description = 5;
   */
  description: string;
};

/**
 * Describes the message tempus.v1.AddExerciseImageRequest.
 * Use `create(AddExerciseImageRequestSchema)` to create a new message.
 */
export const AddExerciseImageRequestSchema: GenMessage<AddExerciseImageRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 25);

/**
 * GetExerciseImageRequest is used to get an image
 *
 * @generated from message tempus.v1.GetExerciseImageRequest
 */
export type GetExerciseImageRequest = Message<"tempus.v1.GetExerciseImageRequest"> & {
  /**
   * @generated from field: int32 exercise_id = 1;
   */
  exerciseId: number;

  /**
   * @generated from field: int32 image_id = 2;
   */
  imageId: number;
};

/**
 * Describes the message tempus.v1.GetExerciseImageRequest.
 * Use `create(GetExerciseImageRequestSchema)` to create a new message.
 */
export const GetExerciseImageRequestSchema: GenMessage<GetExerciseImageRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 26);

/**
 * UpdateExerciseImageRequest is used to update an image's annotation (free-form
 * description text and/or its tie-back to a variation).
 *
 * @generated from message tempus.v1.UpdateExerciseImageRequest
 */
export type UpdateExerciseImageRequest = Message<"tempus.v1.UpdateExerciseImageRequest"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: tempus.v1.ExerciseImage image = 2;
   */
  image?: ExerciseImage | undefined;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 3;
   */
  updateMask?: FieldMask | undefined;
};

/**
 * Describes the message tempus.v1.UpdateExerciseImageRequest.
 * Use `create(UpdateExerciseImageRequestSchema)` to create a new message.
 */
export const UpdateExerciseImageRequestSchema: GenMessage<UpdateExerciseImageRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 27);

/**
 * DeleteExerciseImageRequest is used to delete an image from an exercise
 *
 * @generated from message tempus.v1.DeleteExerciseImageRequest
 */
export type DeleteExerciseImageRequest = Message<"tempus.v1.DeleteExerciseImageRequest"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;
};

/**
 * Describes the message tempus.v1.DeleteExerciseImageRequest.
 * Use `create(DeleteExerciseImageRequestSchema)` to create a new message.
 */
export const DeleteExerciseImageRequestSchema: GenMessage<DeleteExerciseImageRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 28);

/**
 * AddExerciseLinkRequest is used to add a link to an exercise
 *
 * @generated from message tempus.v1.AddExerciseLinkRequest
 */
export type AddExerciseLinkRequest = Message<"tempus.v1.AddExerciseLinkRequest"> & {
  /**
   * @generated from field: int32 exercise_id = 1;
   */
  exerciseId: number;

  /**
   * @generated from field: string url = 2;
   */
  url: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;
};

/**
 * Describes the message tempus.v1.AddExerciseLinkRequest.
 * Use `create(AddExerciseLinkRequestSchema)` to create a new message.
 */
export const AddExerciseLinkRequestSchema: GenMessage<AddExerciseLinkRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 29);

/**
 * DeleteExerciseLinkRequest is used to delete a link from an exercise
 *
 * @generated from message tempus.v1.DeleteExerciseLinkRequest
 */
export type DeleteExerciseLinkRequest = Message<"tempus.v1.DeleteExerciseLinkRequest"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;
};

/**
 * Describes the message tempus.v1.DeleteExerciseLinkRequest.
 * Use `create(DeleteExerciseLinkRequestSchema)` to create a new message.
 */
export const DeleteExerciseLinkRequestSchema: GenMessage<DeleteExerciseLinkRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 30);

/**
 * CreateVariationRequest is used to create a new variation of an exercise
 *
 * @generated from message tempus.v1.CreateVariationRequest
 */
export type CreateVariationRequest = Message<"tempus.v1.CreateVariationRequest"> & {
  /**
   * The parent exercise this is a variation of
   *
   * @generated from field: int32 parent_exercise_id = 1;
   */
  parentExerciseId: number;

  /**
   * Name of the variation (e.g., "RLLR sticking")
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * Optional description
   *
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * Optional JSON-encoded drum notation
   *
   * @generated from field: string notation_json = 4;
   */
  notationJson: string;

  /**
   * Optional target/working tempo for this variation
   *
   * @generated from field: optional int32 target_bpm = 5;
   */
  targetBpm?: number | undefined;
};

/**
 * Describes the message tempus.v1.CreateVariationRequest.
 * Use `create(CreateVariationRequestSchema)` to create a new message.
 */
export const CreateVariationRequestSchema: GenMessage<CreateVariationRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 31);

/**
 * ListVariationsRequest is used to list variations of an exercise
 *
 * @generated from message tempus.v1.ListVariationsRequest
 */
export type ListVariationsRequest = Message<"tempus.v1.ListVariationsRequest"> & {
  /**
   * @generated from field: int32 parent_exercise_id = 1;
   */
  parentExerciseId: number;
};

/**
 * Describes the message tempus.v1.ListVariationsRequest.
 * Use `create(ListVariationsRequestSchema)` to create a new message.
 */
export const ListVariationsRequestSchema: GenMessage<ListVariationsRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 32);

/**
 * ListVariationsResponse contains a list of variations
 *
 * @generated from message tempus.v1.ListVariationsResponse
 */
export type ListVariationsResponse = Message<"tempus.v1.ListVariationsResponse"> & {
  /**
   * @generated from field: repeated tempus.v1.Exercise variations = 1;
   */
  variations: Exercise[];
};

/**
 * Describes the message tempus.v1.ListVariationsResponse.
 * Use `create(ListVariationsResponseSchema)` to create a new message.
 */
export const ListVariationsResponseSchema: GenMessage<ListVariationsResponse> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 33);

/**
 * CreatePracticeSessionRequest is used to create a new practice session
 *
 * @generated from message tempus.v1.CreatePracticeSessionRequest
 */
export type CreatePracticeSessionRequest = Message<"tempus.v1.CreatePracticeSessionRequest"> & {
  /**
   * @generated from field: google.protobuf.Timestamp start_time = 1;
   */
  startTime?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp end_time = 2;
   */
  endTime?: Timestamp | undefined;

  /**
   * @generated from field: string notes = 3;
   */
  notes: string;

  /**
   * @generated from field: optional int32 source_tag_id = 4;
   */
  sourceTagId?: number | undefined;
};

/**
 * Describes the message tempus.v1.CreatePracticeSessionRequest.
 * Use `create(CreatePracticeSessionRequestSchema)` to create a new message.
 */
export const CreatePracticeSessionRequestSchema: GenMessage<CreatePracticeSessionRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 34);

/**
 * GetPracticeSessionRequest is used to retrieve a specific practice session
 *
 * @generated from message tempus.v1.GetPracticeSessionRequest
 */
export type GetPracticeSessionRequest = Message<"tempus.v1.GetPracticeSessionRequest"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;
};

/**
 * Describes the message tempus.v1.GetPracticeSessionRequest.
 * Use `create(GetPracticeSessionRequestSchema)` to create a new message.
 */
export const GetPracticeSessionRequestSchema: GenMessage<GetPracticeSessionRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 35);

/**
 * ListPracticeSessionsRequest is used to list practice sessions with pagination
 *
 * @generated from message tempus.v1.ListPracticeSessionsRequest
 */
export type ListPracticeSessionsRequest = Message<"tempus.v1.ListPracticeSessionsRequest"> & {
  /**
   * @generated from field: int32 page_size = 1;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 2;
   */
  pageToken: string;

  /**
   * Optional: filter by date range
   *
   * @generated from field: google.protobuf.Timestamp start_date = 3;
   */
  startDate?: Timestamp | undefined;

  /**
   * Optional: filter by date range
   *
   * @generated from field: google.protobuf.Timestamp end_date = 4;
   */
  endDate?: Timestamp | undefined;

  /**
   * Optional: filter by exercise
   *
   * @generated from field: int32 exercise_id = 5;
   */
  exerciseId: number;

  /**
   * Optional: filter for active
   *
   * @generated from field: bool active = 6;
   */
  active: boolean;
};

/**
 * Describes the message tempus.v1.ListPracticeSessionsRequest.
 * Use `create(ListPracticeSessionsRequestSchema)` to create a new message.
 */
export const ListPracticeSessionsRequestSchema: GenMessage<ListPracticeSessionsRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 36);

/**
 * ListPracticeSessionsResponse contains a list of practice sessions and
 * pagination info
 *
 * @generated from message tempus.v1.ListPracticeSessionsResponse
 */
export type ListPracticeSessionsResponse = Message<"tempus.v1.ListPracticeSessionsResponse"> & {
  /**
   * @generated from field: repeated tempus.v1.PracticeSession sessions = 1;
   */
  sessions: PracticeSession[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * @generated from field: int32 total_count = 3;
   */
  totalCount: number;
};

/**
 * Describes the message tempus.v1.ListPracticeSessionsResponse.
 * Use `create(ListPracticeSessionsResponseSchema)` to create a new message.
 */
export const ListPracticeSessionsResponseSchema: GenMessage<ListPracticeSessionsResponse> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 37);

/**
 * UpdatePracticeSessionRequest is used to update a practice session
 *
 * @generated from message tempus.v1.UpdatePracticeSessionRequest
 */
export type UpdatePracticeSessionRequest = Message<"tempus.v1.UpdatePracticeSessionRequest"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: tempus.v1.PracticeSession session = 2;
   */
  session?: PracticeSession | undefined;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 3;
   */
  updateMask?: FieldMask | undefined;
};

/**
 * Describes the message tempus.v1.UpdatePracticeSessionRequest.
 * Use `create(UpdatePracticeSessionRequestSchema)` to create a new message.
 */
export const UpdatePracticeSessionRequestSchema: GenMessage<UpdatePracticeSessionRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 38);

/**
 * DeletePracticeSessionRequest is used to delete a practice session
 *
 * @generated from message tempus.v1.DeletePracticeSessionRequest
 */
export type DeletePracticeSessionRequest = Message<"tempus.v1.DeletePracticeSessionRequest"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;
};

/**
 * Describes the message tempus.v1.DeletePracticeSessionRequest.
 * Use `create(DeletePracticeSessionRequestSchema)` to create a new message.
 */
export const DeletePracticeSessionRequestSchema: GenMessage<DeletePracticeSessionRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 39);

/**
 * CreateExerciseHistoryRequest is used to create a new exercise history entry
 *
 * @generated from message tempus.v1.CreateExerciseHistoryRequest
 */
export type CreateExerciseHistoryRequest = Message<"tempus.v1.CreateExerciseHistoryRequest"> & {
  /**
   * @generated from field: int32 exercise_id = 1;
   */
  exerciseId: number;

  /**
   * @generated from field: google.protobuf.Timestamp start_time = 2;
   */
  startTime?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp end_time = 3;
   */
  endTime?: Timestamp | undefined;

  /**
   * @generated from field: repeated int32 bpms = 4;
   */
  bpms: number[];

  /**
   * @generated from field: string notes = 6;
   */
  notes: string;

  /**
   * @generated from field: int32 rating = 7;
   */
  rating: number;

  /**
   * @generated from field: int32 session_id = 8;
   */
  sessionId: number;

  /**
   * @generated from field: int32 duration_seconds = 9;
   */
  durationSeconds: number;

  /**
   * Categories selected at practice time
   *
   * @generated from field: repeated int32 category_ids = 10;
   */
  categoryIds: number[];
};

/**
 * Describes the message tempus.v1.CreateExerciseHistoryRequest.
 * Use `create(CreateExerciseHistoryRequestSchema)` to create a new message.
 */
export const CreateExerciseHistoryRequestSchema: GenMessage<CreateExerciseHistoryRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 40);

/**
 * GetExerciseHistoryRequest is used to retrieve a specific exercise history
 * entry
 *
 * @generated from message tempus.v1.GetExerciseHistoryRequest
 */
export type GetExerciseHistoryRequest = Message<"tempus.v1.GetExerciseHistoryRequest"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;
};

/**
 * Describes the message tempus.v1.GetExerciseHistoryRequest.
 * Use `create(GetExerciseHistoryRequestSchema)` to create a new message.
 */
export const GetExerciseHistoryRequestSchema: GenMessage<GetExerciseHistoryRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 41);

/**
 * ListExerciseHistoryRequest is used to list exercise history entries with
 * pagination
 *
 * @generated from message tempus.v1.ListExerciseHistoryRequest
 */
export type ListExerciseHistoryRequest = Message<"tempus.v1.ListExerciseHistoryRequest"> & {
  /**
   * @generated from field: int32 page_size = 1;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 2;
   */
  pageToken: string;

  /**
   * Optional: filter by exercise
   *
   * @generated from field: int32 exercise_id = 3;
   */
  exerciseId: number;

  /**
   * Optional: filter by date range
   *
   * @generated from field: google.protobuf.Timestamp start_date = 4;
   */
  startDate?: Timestamp | undefined;

  /**
   * Optional: filter by date range
   *
   * @generated from field: google.protobuf.Timestamp end_date = 5;
   */
  endDate?: Timestamp | undefined;

  /**
   * Optional: filter by session
   *
   * @generated from field: int32 session_id = 6;
   */
  sessionId: number;
};

/**
 * Describes the message tempus.v1.ListExerciseHistoryRequest.
 * Use `create(ListExerciseHistoryRequestSchema)` to create a new message.
 */
export const ListExerciseHistoryRequestSchema: GenMessage<ListExerciseHistoryRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 42);

/**
 * ListExerciseHistoryResponse contains a list of exercise history entries and
 * pagination info
 *
 * @generated from message tempus.v1.ListExerciseHistoryResponse
 */
export type ListExerciseHistoryResponse = Message<"tempus.v1.ListExerciseHistoryResponse"> & {
  /**
   * @generated from field: repeated tempus.v1.ExerciseHistory history_entries = 1;
   */
  historyEntries: ExerciseHistory[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * @generated from field: int32 total_count = 3;
   */
  totalCount: number;
};

/**
 * Describes the message tempus.v1.ListExerciseHistoryResponse.
 * Use `create(ListExerciseHistoryResponseSchema)` to create a new message.
 */
export const ListExerciseHistoryResponseSchema: GenMessage<ListExerciseHistoryResponse> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 43);

/**
 * UpdateExerciseHistoryRequest is used to update an exercise history entry
 *
 * @generated from message tempus.v1.UpdateExerciseHistoryRequest
 */
export type UpdateExerciseHistoryRequest = Message<"tempus.v1.UpdateExerciseHistoryRequest"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: tempus.v1.ExerciseHistory history = 2;
   */
  history?: ExerciseHistory | undefined;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 3;
   */
  updateMask?: FieldMask | undefined;
};

/**
 * Describes the message tempus.v1.UpdateExerciseHistoryRequest.
 * Use `create(UpdateExerciseHistoryRequestSchema)` to create a new message.
 */
export const UpdateExerciseHistoryRequestSchema: GenMessage<UpdateExerciseHistoryRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 44);

/**
 * DeleteExerciseHistoryRequest is used to delete an exercise history entry
 *
 * @generated from message tempus.v1.DeleteExerciseHistoryRequest
 */
export type DeleteExerciseHistoryRequest = Message<"tempus.v1.DeleteExerciseHistoryRequest"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;
};

/**
 * Describes the message tempus.v1.DeleteExerciseHistoryRequest.
 * Use `create(DeleteExerciseHistoryRequestSchema)` to create a new message.
 */
export const DeleteExerciseHistoryRequestSchema: GenMessage<DeleteExerciseHistoryRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 45);

/**
 * GetExerciseStatsRequest is used to get statistics for an exercise
 *
 * @generated from message tempus.v1.GetExerciseStatsRequest
 */
export type GetExerciseStatsRequest = Message<"tempus.v1.GetExerciseStatsRequest"> & {
  /**
   * @generated from field: int32 exercise_id = 1;
   */
  exerciseId: number;

  /**
   * Optional: filter by date range
   *
   * @generated from field: google.protobuf.Timestamp start_date = 2;
   */
  startDate?: Timestamp | undefined;

  /**
   * Optional: filter by date range
   *
   * @generated from field: google.protobuf.Timestamp end_date = 3;
   */
  endDate?: Timestamp | undefined;

  /**
   * Minutes to add to UTC to reach the client's local time, used to bucket the
   * BPM-progress chart by local calendar date (e.g. -240 for EDT).
   * Send -(new Date().getTimezoneOffset()). Defaults to 0 (UTC) when omitted.
   *
   * @generated from field: int32 tz_offset_minutes = 4;
   */
  tzOffsetMinutes: number;
};

/**
 * Describes the message tempus.v1.GetExerciseStatsRequest.
 * Use `create(GetExerciseStatsRequestSchema)` to create a new message.
 */
export const GetExerciseStatsRequestSchema: GenMessage<GetExerciseStatsRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 46);

/**
 * ExerciseStats contains statistics for an exercise
 *
 * @generated from message tempus.v1.ExerciseStats
 */
export type ExerciseStats = Message<"tempus.v1.ExerciseStats"> & {
  /**
   * @generated from field: int32 exercise_id = 1;
   */
  exerciseId: number;

  /**
   * @generated from field: string exercise_name = 2;
   */
  exerciseName: string;

  /**
   * @generated from field: int32 practice_count = 3;
   */
  practiceCount: number;

  /**
   * @generated from field: int32 total_practice_duration_seconds = 4;
   */
  totalPracticeDurationSeconds: number;

  /**
   * @generated from field: double avg_rating = 5;
   */
  avgRating: number;

  /**
   * @generated from field: int32 max_bpm = 6;
   */
  maxBpm: number;

  /**
   * @generated from field: int32 min_bpm = 7;
   */
  minBpm: number;

  /**
   * @generated from field: double avg_bpm = 8;
   */
  avgBpm: number;

  /**
   * @generated from field: repeated tempus.v1.BpmProgressPoint bpm_progress = 9;
   */
  bpmProgress: BpmProgressPoint[];
};

/**
 * Describes the message tempus.v1.ExerciseStats.
 * Use `create(ExerciseStatsSchema)` to create a new message.
 */
export const ExerciseStatsSchema: GenMessage<ExerciseStats> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 47);

/**
 * BpmProgressPoint represents a point in the BPM progress chart
 *
 * @generated from message tempus.v1.BpmProgressPoint
 */
export type BpmProgressPoint = Message<"tempus.v1.BpmProgressPoint"> & {
  /**
   * @generated from field: google.protobuf.Timestamp date = 1;
   */
  date?: Timestamp | undefined;

  /**
   * @generated from field: int32 bpm = 2;
   */
  bpm: number;
};

/**
 * Describes the message tempus.v1.BpmProgressPoint.
 * Use `create(BpmProgressPointSchema)` to create a new message.
 */
export const BpmProgressPointSchema: GenMessage<BpmProgressPoint> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 48);

/**
 * GetPracticeStatsRequest is used to get statistics for practice sessions
 *
 * @generated from message tempus.v1.GetPracticeStatsRequest
 */
export type GetPracticeStatsRequest = Message<"tempus.v1.GetPracticeStatsRequest"> & {
  /**
   * Optional: filter by date range
   *
   * @generated from field: google.protobuf.Timestamp start_date = 1;
   */
  startDate?: Timestamp | undefined;

  /**
   * Optional: filter by date range
   *
   * @generated from field: google.protobuf.Timestamp end_date = 2;
   */
  endDate?: Timestamp | undefined;

  /**
   * Optional: filter by category
   *
   * @generated from field: int32 category_id = 3;
   */
  categoryId: number;

  /**
   * Minutes to add to UTC to reach the client's local time, used to bucket the
   * practice-frequency charts by local calendar date (e.g. -240 for EDT).
   * Send -(new Date().getTimezoneOffset()). Defaults to 0 (UTC) when omitted.
   *
   * @generated from field: int32 tz_offset_minutes = 4;
   */
  tzOffsetMinutes: number;
};

/**
 * Describes the message tempus.v1.GetPracticeStatsRequest.
 * Use `create(GetPracticeStatsRequestSchema)` to create a new message.
 */
export const GetPracticeStatsRequestSchema: GenMessage<GetPracticeStatsRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 49);

/**
 * PracticeStats contains statistics for practice sessions
 *
 * @generated from message tempus.v1.PracticeStats
 */
export type PracticeStats = Message<"tempus.v1.PracticeStats"> & {
  /**
   * @generated from field: int32 total_sessions = 1;
   */
  totalSessions: number;

  /**
   * @generated from field: int32 total_duration_seconds = 2;
   */
  totalDurationSeconds: number;

  /**
   * @generated from field: double avg_session_duration_seconds = 3;
   */
  avgSessionDurationSeconds: number;

  /**
   * @generated from field: repeated tempus.v1.ExerciseTimeDistribution exercise_distribution = 4;
   */
  exerciseDistribution: ExerciseTimeDistribution[];

  /**
   * @generated from field: repeated tempus.v1.CategoryTimeDistribution category_distribution = 5;
   */
  categoryDistribution: CategoryTimeDistribution[];

  /**
   * @generated from field: repeated tempus.v1.PracticeTimePoint practice_frequency = 6;
   */
  practiceFrequency: PracticeTimePoint[];
};

/**
 * Describes the message tempus.v1.PracticeStats.
 * Use `create(PracticeStatsSchema)` to create a new message.
 */
export const PracticeStatsSchema: GenMessage<PracticeStats> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 50);

/**
 * ExerciseTimeDistribution shows how much time was spent on each exercise
 *
 * @generated from message tempus.v1.ExerciseTimeDistribution
 */
export type ExerciseTimeDistribution = Message<"tempus.v1.ExerciseTimeDistribution"> & {
  /**
   * @generated from field: int32 exercise_id = 1;
   */
  exerciseId: number;

  /**
   * @generated from field: string exercise_name = 2;
   */
  exerciseName: string;

  /**
   * @generated from field: int32 duration_seconds = 3;
   */
  durationSeconds: number;

  /**
   * @generated from field: double percentage = 4;
   */
  percentage: number;
};

/**
 * Describes the message tempus.v1.ExerciseTimeDistribution.
 * Use `create(ExerciseTimeDistributionSchema)` to create a new message.
 */
export const ExerciseTimeDistributionSchema: GenMessage<ExerciseTimeDistribution> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 51);

/**
 * CategoryTimeDistribution shows how much time was spent on each category
 *
 * @generated from message tempus.v1.CategoryTimeDistribution
 */
export type CategoryTimeDistribution = Message<"tempus.v1.CategoryTimeDistribution"> & {
  /**
   * @generated from field: int32 category_id = 1;
   */
  categoryId: number;

  /**
   * @generated from field: string category_name = 2;
   */
  categoryName: string;

  /**
   * @generated from field: int32 duration_seconds = 3;
   */
  durationSeconds: number;

  /**
   * @generated from field: double percentage = 4;
   */
  percentage: number;

  /**
   * @generated from field: repeated tempus.v1.PracticeTimePoint practice_frequency = 5;
   */
  practiceFrequency: PracticeTimePoint[];
};

/**
 * Describes the message tempus.v1.CategoryTimeDistribution.
 * Use `create(CategoryTimeDistributionSchema)` to create a new message.
 */
export const CategoryTimeDistributionSchema: GenMessage<CategoryTimeDistribution> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 52);

/**
 * PracticeTimePoint represents a point in the practice frequency chart
 *
 * @generated from message tempus.v1.PracticeTimePoint
 */
export type PracticeTimePoint = Message<"tempus.v1.PracticeTimePoint"> & {
  /**
   * @generated from field: google.protobuf.Timestamp date = 1;
   */
  date?: Timestamp | undefined;

  /**
   * @generated from field: int32 duration_seconds = 2;
   */
  durationSeconds: number;
};

/**
 * Describes the message tempus.v1.PracticeTimePoint.
 * Use `create(PracticeTimePointSchema)` to create a new message.
 */
export const PracticeTimePointSchema: GenMessage<PracticeTimePoint> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 53);

/**
 * NewBreedSystem represents one of the 39 systems (grooves) from The New Breed
 *
 * @generated from message tempus.v1.NewBreedSystem
 */
export type NewBreedSystem = Message<"tempus.v1.NewBreedSystem"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: int32 number = 2;
   */
  number: number;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * 'basic' or 'advanced'
   *
   * @generated from field: string section = 5;
   */
  section: string;
};

/**
 * Describes the message tempus.v1.NewBreedSystem.
 * Use `create(NewBreedSystemSchema)` to create a new message.
 */
export const NewBreedSystemSchema: GenMessage<NewBreedSystem> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 54);

/**
 * NewBreedMelodyPage represents a page of melodies (e.g., "1A", "2B")
 *
 * @generated from message tempus.v1.NewBreedMelodyPage
 */
export type NewBreedMelodyPage = Message<"tempus.v1.NewBreedMelodyPage"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * @generated from field: int32 sort_order = 3;
   */
  sortOrder: number;

  /**
   * @generated from field: repeated tempus.v1.NewBreedMelody melodies = 4;
   */
  melodies: NewBreedMelody[];
};

/**
 * Describes the message tempus.v1.NewBreedMelodyPage.
 * Use `create(NewBreedMelodyPageSchema)` to create a new message.
 */
export const NewBreedMelodyPageSchema: GenMessage<NewBreedMelodyPage> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 55);

/**
 * NewBreedMelody represents an individual melody on a page
 *
 * @generated from message tempus.v1.NewBreedMelody
 */
export type NewBreedMelody = Message<"tempus.v1.NewBreedMelody"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: int32 page_id = 2;
   */
  pageId: number;

  /**
   * @generated from field: int32 number = 3;
   */
  number: number;
};

/**
 * Describes the message tempus.v1.NewBreedMelody.
 * Use `create(NewBreedMelodySchema)` to create a new message.
 */
export const NewBreedMelodySchema: GenMessage<NewBreedMelody> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 56);

/**
 * NewBreedPracticeEntry represents a practice log entry for a system+page combination
 *
 * @generated from message tempus.v1.NewBreedPracticeEntry
 */
export type NewBreedPracticeEntry = Message<"tempus.v1.NewBreedPracticeEntry"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: int32 session_id = 2;
   */
  sessionId: number;

  /**
   * @generated from field: int32 system_id = 3;
   */
  systemId: number;

  /**
   * @generated from field: int32 page_id = 4;
   */
  pageId: number;

  /**
   * 'page' or 'melody'
   *
   * @generated from field: string granularity = 5;
   */
  granularity: string;

  /**
   * @generated from field: google.protobuf.Timestamp start_time = 6;
   */
  startTime?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp end_time = 7;
   */
  endTime?: Timestamp | undefined;

  /**
   * @generated from field: repeated int32 bpms = 8;
   */
  bpms: number[];

  /**
   * @generated from field: string notes = 9;
   */
  notes: string;

  /**
   * @generated from field: int32 rating = 10;
   */
  rating: number;

  /**
   * @generated from field: int32 duration_seconds = 11;
   */
  durationSeconds: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 12;
   */
  createdAt?: Timestamp | undefined;

  /**
   * populated when granularity='melody'
   *
   * @generated from field: repeated int32 melody_ids = 13;
   */
  melodyIds: number[];

  /**
   * denormalized for display
   *
   * @generated from field: tempus.v1.NewBreedSystem system = 14;
   */
  system?: NewBreedSystem | undefined;

  /**
   * denormalized for display
   *
   * @generated from field: tempus.v1.NewBreedMelodyPage page = 15;
   */
  page?: NewBreedMelodyPage | undefined;
};

/**
 * Describes the message tempus.v1.NewBreedPracticeEntry.
 * Use `create(NewBreedPracticeEntrySchema)` to create a new message.
 */
export const NewBreedPracticeEntrySchema: GenMessage<NewBreedPracticeEntry> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 57);

/**
 * NewBreedProgressCell represents progress for one system+page combination in the matrix
 *
 * @generated from message tempus.v1.NewBreedProgressCell
 */
export type NewBreedProgressCell = Message<"tempus.v1.NewBreedProgressCell"> & {
  /**
   * @generated from field: int32 system_id = 1;
   */
  systemId: number;

  /**
   * @generated from field: int32 system_number = 2;
   */
  systemNumber: number;

  /**
   * @generated from field: int32 page_id = 3;
   */
  pageId: number;

  /**
   * @generated from field: string page_label = 4;
   */
  pageLabel: string;

  /**
   * @generated from field: int32 practice_count = 5;
   */
  practiceCount: number;

  /**
   * @generated from field: google.protobuf.Timestamp last_practiced = 6;
   */
  lastPracticed?: Timestamp | undefined;

  /**
   * @generated from field: int32 max_bpm = 7;
   */
  maxBpm: number;

  /**
   * @generated from field: double avg_rating = 8;
   */
  avgRating: number;

  /**
   * @generated from field: int32 total_duration_seconds = 9;
   */
  totalDurationSeconds: number;
};

/**
 * Describes the message tempus.v1.NewBreedProgressCell.
 * Use `create(NewBreedProgressCellSchema)` to create a new message.
 */
export const NewBreedProgressCellSchema: GenMessage<NewBreedProgressCell> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 58);

/**
 * NewBreedSystemProgress represents detailed progress for a single system
 *
 * @generated from message tempus.v1.NewBreedSystemProgress
 */
export type NewBreedSystemProgress = Message<"tempus.v1.NewBreedSystemProgress"> & {
  /**
   * @generated from field: tempus.v1.NewBreedSystem system = 1;
   */
  system?: NewBreedSystem | undefined;

  /**
   * @generated from field: repeated tempus.v1.NewBreedPageProgress pages = 2;
   */
  pages: NewBreedPageProgress[];

  /**
   * @generated from field: int32 total_practice_count = 3;
   */
  totalPracticeCount: number;

  /**
   * @generated from field: int32 total_duration_seconds = 4;
   */
  totalDurationSeconds: number;
};

/**
 * Describes the message tempus.v1.NewBreedSystemProgress.
 * Use `create(NewBreedSystemProgressSchema)` to create a new message.
 */
export const NewBreedSystemProgressSchema: GenMessage<NewBreedSystemProgress> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 59);

/**
 * NewBreedPageProgress represents progress for one page within a system
 *
 * @generated from message tempus.v1.NewBreedPageProgress
 */
export type NewBreedPageProgress = Message<"tempus.v1.NewBreedPageProgress"> & {
  /**
   * @generated from field: tempus.v1.NewBreedMelodyPage page = 1;
   */
  page?: NewBreedMelodyPage | undefined;

  /**
   * @generated from field: int32 practice_count = 2;
   */
  practiceCount: number;

  /**
   * @generated from field: google.protobuf.Timestamp last_practiced = 3;
   */
  lastPracticed?: Timestamp | undefined;

  /**
   * @generated from field: int32 max_bpm = 4;
   */
  maxBpm: number;

  /**
   * @generated from field: repeated tempus.v1.NewBreedMelodyProgress melodies = 5;
   */
  melodies: NewBreedMelodyProgress[];
};

/**
 * Describes the message tempus.v1.NewBreedPageProgress.
 * Use `create(NewBreedPageProgressSchema)` to create a new message.
 */
export const NewBreedPageProgressSchema: GenMessage<NewBreedPageProgress> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 60);

/**
 * NewBreedMelodyProgress represents progress for one melody within a page
 *
 * @generated from message tempus.v1.NewBreedMelodyProgress
 */
export type NewBreedMelodyProgress = Message<"tempus.v1.NewBreedMelodyProgress"> & {
  /**
   * @generated from field: tempus.v1.NewBreedMelody melody = 1;
   */
  melody?: NewBreedMelody | undefined;

  /**
   * @generated from field: int32 practice_count = 2;
   */
  practiceCount: number;

  /**
   * @generated from field: google.protobuf.Timestamp last_practiced = 3;
   */
  lastPracticed?: Timestamp | undefined;
};

/**
 * Describes the message tempus.v1.NewBreedMelodyProgress.
 * Use `create(NewBreedMelodyProgressSchema)` to create a new message.
 */
export const NewBreedMelodyProgressSchema: GenMessage<NewBreedMelodyProgress> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 61);

/**
 * @generated from message tempus.v1.ListSystemsRequest
 */
export type ListSystemsRequest = Message<"tempus.v1.ListSystemsRequest"> & {
};

/**
 * Describes the message tempus.v1.ListSystemsRequest.
 * Use `create(ListSystemsRequestSchema)` to create a new message.
 */
export const ListSystemsRequestSchema: GenMessage<ListSystemsRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 62);

/**
 * @generated from message tempus.v1.ListSystemsResponse
 */
export type ListSystemsResponse = Message<"tempus.v1.ListSystemsResponse"> & {
  /**
   * @generated from field: repeated tempus.v1.NewBreedSystem systems = 1;
   */
  systems: NewBreedSystem[];
};

/**
 * Describes the message tempus.v1.ListSystemsResponse.
 * Use `create(ListSystemsResponseSchema)` to create a new message.
 */
export const ListSystemsResponseSchema: GenMessage<ListSystemsResponse> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 63);

/**
 * @generated from message tempus.v1.ListMelodyPagesRequest
 */
export type ListMelodyPagesRequest = Message<"tempus.v1.ListMelodyPagesRequest"> & {
};

/**
 * Describes the message tempus.v1.ListMelodyPagesRequest.
 * Use `create(ListMelodyPagesRequestSchema)` to create a new message.
 */
export const ListMelodyPagesRequestSchema: GenMessage<ListMelodyPagesRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 64);

/**
 * @generated from message tempus.v1.ListMelodyPagesResponse
 */
export type ListMelodyPagesResponse = Message<"tempus.v1.ListMelodyPagesResponse"> & {
  /**
   * @generated from field: repeated tempus.v1.NewBreedMelodyPage pages = 1;
   */
  pages: NewBreedMelodyPage[];
};

/**
 * Describes the message tempus.v1.ListMelodyPagesResponse.
 * Use `create(ListMelodyPagesResponseSchema)` to create a new message.
 */
export const ListMelodyPagesResponseSchema: GenMessage<ListMelodyPagesResponse> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 65);

/**
 * @generated from message tempus.v1.CreatePracticeEntryRequest
 */
export type CreatePracticeEntryRequest = Message<"tempus.v1.CreatePracticeEntryRequest"> & {
  /**
   * @generated from field: int32 session_id = 1;
   */
  sessionId: number;

  /**
   * @generated from field: int32 system_id = 2;
   */
  systemId: number;

  /**
   * @generated from field: int32 page_id = 3;
   */
  pageId: number;

  /**
   * @generated from field: string granularity = 4;
   */
  granularity: string;

  /**
   * @generated from field: google.protobuf.Timestamp start_time = 5;
   */
  startTime?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp end_time = 6;
   */
  endTime?: Timestamp | undefined;

  /**
   * @generated from field: repeated int32 bpms = 7;
   */
  bpms: number[];

  /**
   * @generated from field: string notes = 8;
   */
  notes: string;

  /**
   * @generated from field: int32 rating = 9;
   */
  rating: number;

  /**
   * @generated from field: int32 duration_seconds = 10;
   */
  durationSeconds: number;

  /**
   * @generated from field: repeated int32 melody_ids = 11;
   */
  melodyIds: number[];
};

/**
 * Describes the message tempus.v1.CreatePracticeEntryRequest.
 * Use `create(CreatePracticeEntryRequestSchema)` to create a new message.
 */
export const CreatePracticeEntryRequestSchema: GenMessage<CreatePracticeEntryRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 66);

/**
 * @generated from message tempus.v1.GetPracticeEntryRequest
 */
export type GetPracticeEntryRequest = Message<"tempus.v1.GetPracticeEntryRequest"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;
};

/**
 * Describes the message tempus.v1.GetPracticeEntryRequest.
 * Use `create(GetPracticeEntryRequestSchema)` to create a new message.
 */
export const GetPracticeEntryRequestSchema: GenMessage<GetPracticeEntryRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 67);

/**
 * @generated from message tempus.v1.ListPracticeEntriesRequest
 */
export type ListPracticeEntriesRequest = Message<"tempus.v1.ListPracticeEntriesRequest"> & {
  /**
   * @generated from field: int32 session_id = 1;
   */
  sessionId: number;

  /**
   * @generated from field: int32 system_id = 2;
   */
  systemId: number;

  /**
   * @generated from field: int32 page_id = 3;
   */
  pageId: number;

  /**
   * @generated from field: int32 page_size = 4;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 5;
   */
  pageToken: string;
};

/**
 * Describes the message tempus.v1.ListPracticeEntriesRequest.
 * Use `create(ListPracticeEntriesRequestSchema)` to create a new message.
 */
export const ListPracticeEntriesRequestSchema: GenMessage<ListPracticeEntriesRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 68);

/**
 * @generated from message tempus.v1.ListPracticeEntriesResponse
 */
export type ListPracticeEntriesResponse = Message<"tempus.v1.ListPracticeEntriesResponse"> & {
  /**
   * @generated from field: repeated tempus.v1.NewBreedPracticeEntry entries = 1;
   */
  entries: NewBreedPracticeEntry[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * @generated from field: int32 total_count = 3;
   */
  totalCount: number;
};

/**
 * Describes the message tempus.v1.ListPracticeEntriesResponse.
 * Use `create(ListPracticeEntriesResponseSchema)` to create a new message.
 */
export const ListPracticeEntriesResponseSchema: GenMessage<ListPracticeEntriesResponse> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 69);

/**
 * @generated from message tempus.v1.UpdatePracticeEntryRequest
 */
export type UpdatePracticeEntryRequest = Message<"tempus.v1.UpdatePracticeEntryRequest"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: tempus.v1.NewBreedPracticeEntry entry = 2;
   */
  entry?: NewBreedPracticeEntry | undefined;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 3;
   */
  updateMask?: FieldMask | undefined;
};

/**
 * Describes the message tempus.v1.UpdatePracticeEntryRequest.
 * Use `create(UpdatePracticeEntryRequestSchema)` to create a new message.
 */
export const UpdatePracticeEntryRequestSchema: GenMessage<UpdatePracticeEntryRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 70);

/**
 * @generated from message tempus.v1.DeletePracticeEntryRequest
 */
export type DeletePracticeEntryRequest = Message<"tempus.v1.DeletePracticeEntryRequest"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;
};

/**
 * Describes the message tempus.v1.DeletePracticeEntryRequest.
 * Use `create(DeletePracticeEntryRequestSchema)` to create a new message.
 */
export const DeletePracticeEntryRequestSchema: GenMessage<DeletePracticeEntryRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 71);

/**
 * @generated from message tempus.v1.GetMatrixRequest
 */
export type GetMatrixRequest = Message<"tempus.v1.GetMatrixRequest"> & {
  /**
   * @generated from field: google.protobuf.Timestamp start_date = 1;
   */
  startDate?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp end_date = 2;
   */
  endDate?: Timestamp | undefined;
};

/**
 * Describes the message tempus.v1.GetMatrixRequest.
 * Use `create(GetMatrixRequestSchema)` to create a new message.
 */
export const GetMatrixRequestSchema: GenMessage<GetMatrixRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 72);

/**
 * @generated from message tempus.v1.GetMatrixResponse
 */
export type GetMatrixResponse = Message<"tempus.v1.GetMatrixResponse"> & {
  /**
   * @generated from field: repeated tempus.v1.NewBreedProgressCell cells = 1;
   */
  cells: NewBreedProgressCell[];

  /**
   * @generated from field: repeated tempus.v1.NewBreedSystem systems = 2;
   */
  systems: NewBreedSystem[];

  /**
   * @generated from field: repeated tempus.v1.NewBreedMelodyPage pages = 3;
   */
  pages: NewBreedMelodyPage[];
};

/**
 * Describes the message tempus.v1.GetMatrixResponse.
 * Use `create(GetMatrixResponseSchema)` to create a new message.
 */
export const GetMatrixResponseSchema: GenMessage<GetMatrixResponse> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 73);

/**
 * @generated from message tempus.v1.GetSystemProgressRequest
 */
export type GetSystemProgressRequest = Message<"tempus.v1.GetSystemProgressRequest"> & {
  /**
   * @generated from field: int32 system_id = 1;
   */
  systemId: number;

  /**
   * @generated from field: google.protobuf.Timestamp start_date = 2;
   */
  startDate?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp end_date = 3;
   */
  endDate?: Timestamp | undefined;
};

/**
 * Describes the message tempus.v1.GetSystemProgressRequest.
 * Use `create(GetSystemProgressRequestSchema)` to create a new message.
 */
export const GetSystemProgressRequestSchema: GenMessage<GetSystemProgressRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 74);

/**
 * @generated from message tempus.v1.GetSystemProgressResponse
 */
export type GetSystemProgressResponse = Message<"tempus.v1.GetSystemProgressResponse"> & {
  /**
   * @generated from field: tempus.v1.NewBreedSystemProgress progress = 1;
   */
  progress?: NewBreedSystemProgress | undefined;

  /**
   * @generated from field: repeated tempus.v1.NewBreedPracticeEntry recent_entries = 2;
   */
  recentEntries: NewBreedPracticeEntry[];
};

/**
 * Describes the message tempus.v1.GetSystemProgressResponse.
 * Use `create(GetSystemProgressResponseSchema)` to create a new message.
 */
export const GetSystemProgressResponseSchema: GenMessage<GetSystemProgressResponse> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 75);

/**
 * @generated from message tempus.v1.Setting
 */
export type Setting = Message<"tempus.v1.Setting"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * @generated from field: string value = 2;
   */
  value: string;
};

/**
 * Describes the message tempus.v1.Setting.
 * Use `create(SettingSchema)` to create a new message.
 */
export const SettingSchema: GenMessage<Setting> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 76);

/**
 * @generated from message tempus.v1.GetSettingRequest
 */
export type GetSettingRequest = Message<"tempus.v1.GetSettingRequest"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;
};

/**
 * Describes the message tempus.v1.GetSettingRequest.
 * Use `create(GetSettingRequestSchema)` to create a new message.
 */
export const GetSettingRequestSchema: GenMessage<GetSettingRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 77);

/**
 * @generated from message tempus.v1.GetSettingResponse
 */
export type GetSettingResponse = Message<"tempus.v1.GetSettingResponse"> & {
  /**
   * @generated from field: tempus.v1.Setting setting = 1;
   */
  setting?: Setting | undefined;
};

/**
 * Describes the message tempus.v1.GetSettingResponse.
 * Use `create(GetSettingResponseSchema)` to create a new message.
 */
export const GetSettingResponseSchema: GenMessage<GetSettingResponse> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 78);

/**
 * @generated from message tempus.v1.SetSettingRequest
 */
export type SetSettingRequest = Message<"tempus.v1.SetSettingRequest"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * @generated from field: string value = 2;
   */
  value: string;
};

/**
 * Describes the message tempus.v1.SetSettingRequest.
 * Use `create(SetSettingRequestSchema)` to create a new message.
 */
export const SetSettingRequestSchema: GenMessage<SetSettingRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 79);

/**
 * @generated from message tempus.v1.SetSettingResponse
 */
export type SetSettingResponse = Message<"tempus.v1.SetSettingResponse"> & {
  /**
   * @generated from field: tempus.v1.Setting setting = 1;
   */
  setting?: Setting | undefined;
};

/**
 * Describes the message tempus.v1.SetSettingResponse.
 * Use `create(SetSettingResponseSchema)` to create a new message.
 */
export const SetSettingResponseSchema: GenMessage<SetSettingResponse> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 80);

/**
 * @generated from message tempus.v1.ListSettingsRequest
 */
export type ListSettingsRequest = Message<"tempus.v1.ListSettingsRequest"> & {
};

/**
 * Describes the message tempus.v1.ListSettingsRequest.
 * Use `create(ListSettingsRequestSchema)` to create a new message.
 */
export const ListSettingsRequestSchema: GenMessage<ListSettingsRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 81);

/**
 * @generated from message tempus.v1.ListSettingsResponse
 */
export type ListSettingsResponse = Message<"tempus.v1.ListSettingsResponse"> & {
  /**
   * @generated from field: repeated tempus.v1.Setting settings = 1;
   */
  settings: Setting[];
};

/**
 * Describes the message tempus.v1.ListSettingsResponse.
 * Use `create(ListSettingsResponseSchema)` to create a new message.
 */
export const ListSettingsResponseSchema: GenMessage<ListSettingsResponse> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 82);

/**
 * SrsCard holds the spaced-repetition state for an exercise enrolled in the
 * Review system. There is one card per exercise, and the presence of a card is
 * what marks an exercise as enrolled. Scheduling uses the
 * SM-2 algorithm, with a BPM "ladder" layered on top: mastered_bpm is the
 * tempo the player has banked, and target_bpm is the frontier they are
 * currently pushing toward. Mastering the target advances it by bpm_step.
 *
 * @generated from message tempus.v1.SrsCard
 */
export type SrsCard = Message<"tempus.v1.SrsCard"> & {
  /**
   * @generated from field: int32 exercise_id = 1;
   */
  exerciseId: number;

  /**
   * SM-2 ease factor (clamped to >= 1.3). Higher means intervals grow faster.
   *
   * @generated from field: double ease_factor = 2;
   */
  easeFactor: number;

  /**
   * Current scheduling interval, in days.
   *
   * @generated from field: double interval_days = 3;
   */
  intervalDays: number;

  /**
   * Number of consecutive successful reviews (SM-2 repetition count).
   *
   * @generated from field: int32 repetitions = 4;
   */
  repetitions: number;

  /**
   * When this card is next due for review.
   *
   * @generated from field: google.protobuf.Timestamp due_date = 5;
   */
  dueDate?: Timestamp | undefined;

  /**
   * When this card was last reviewed (unset if never reviewed).
   *
   * @generated from field: google.protobuf.Timestamp last_reviewed = 6;
   */
  lastReviewed?: Timestamp | undefined;

  /**
   * Highest BPM the player has consistently mastered for this exercise.
   *
   * @generated from field: int32 mastered_bpm = 7;
   */
  masteredBpm: number;

  /**
   * How much the exercise's target_bpm advances when a rung is mastered.
   *
   * @generated from field: int32 bpm_step = 9;
   */
  bpmStep: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */
  createdAt?: Timestamp | undefined;

  /**
   * Populated on read RPCs for display convenience (carries target_bpm).
   *
   * @generated from field: tempus.v1.Exercise exercise = 11;
   */
  exercise?: Exercise | undefined;

  /**
   * Whole days this card is overdue (0 if not yet due). Populated on reads.
   *
   * @generated from field: int32 days_overdue = 12;
   */
  daysOverdue: number;
};

/**
 * Describes the message tempus.v1.SrsCard.
 * Use `create(SrsCardSchema)` to create a new message.
 */
export const SrsCardSchema: GenMessage<SrsCard> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 83);

/**
 * @generated from message tempus.v1.EnrollExerciseRequest
 */
export type EnrollExerciseRequest = Message<"tempus.v1.EnrollExerciseRequest"> & {
  /**
   * @generated from field: int32 exercise_id = 1;
   */
  exerciseId: number;

  /**
   * Target BPM to work toward. When > 0, sets Exercise.target_bpm. May be 0 if
   * the exercise already has a target_bpm set; otherwise it is required.
   *
   * @generated from field: int32 target_bpm = 2;
   */
  targetBpm: number;

  /**
   * BPM already mastered before enrolling (defaults to 0).
   *
   * @generated from field: int32 mastered_bpm = 3;
   */
  masteredBpm: number;

  /**
   * Step applied to the exercise's target_bpm when a rung is mastered
   * (defaults to 5).
   *
   * @generated from field: int32 bpm_step = 4;
   */
  bpmStep: number;
};

/**
 * Describes the message tempus.v1.EnrollExerciseRequest.
 * Use `create(EnrollExerciseRequestSchema)` to create a new message.
 */
export const EnrollExerciseRequestSchema: GenMessage<EnrollExerciseRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 84);

/**
 * @generated from message tempus.v1.UnenrollExerciseRequest
 */
export type UnenrollExerciseRequest = Message<"tempus.v1.UnenrollExerciseRequest"> & {
  /**
   * @generated from field: int32 exercise_id = 1;
   */
  exerciseId: number;
};

/**
 * Describes the message tempus.v1.UnenrollExerciseRequest.
 * Use `create(UnenrollExerciseRequestSchema)` to create a new message.
 */
export const UnenrollExerciseRequestSchema: GenMessage<UnenrollExerciseRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 85);

/**
 * @generated from message tempus.v1.GetCardRequest
 */
export type GetCardRequest = Message<"tempus.v1.GetCardRequest"> & {
  /**
   * @generated from field: int32 exercise_id = 1;
   */
  exerciseId: number;
};

/**
 * Describes the message tempus.v1.GetCardRequest.
 * Use `create(GetCardRequestSchema)` to create a new message.
 */
export const GetCardRequestSchema: GenMessage<GetCardRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 86);

/**
 * @generated from message tempus.v1.ListCardsRequest
 */
export type ListCardsRequest = Message<"tempus.v1.ListCardsRequest"> & {
  /**
   * If true, only return cards that are currently due.
   *
   * @generated from field: bool due_only = 1;
   */
  dueOnly: boolean;

  /**
   * Include enrolled archived exercises. They remain excluded by default.
   *
   * @generated from field: bool include_archived = 2;
   */
  includeArchived: boolean;
};

/**
 * Describes the message tempus.v1.ListCardsRequest.
 * Use `create(ListCardsRequestSchema)` to create a new message.
 */
export const ListCardsRequestSchema: GenMessage<ListCardsRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 87);

/**
 * @generated from message tempus.v1.ListCardsResponse
 */
export type ListCardsResponse = Message<"tempus.v1.ListCardsResponse"> & {
  /**
   * @generated from field: repeated tempus.v1.SrsCard cards = 1;
   */
  cards: SrsCard[];
};

/**
 * Describes the message tempus.v1.ListCardsResponse.
 * Use `create(ListCardsResponseSchema)` to create a new message.
 */
export const ListCardsResponseSchema: GenMessage<ListCardsResponse> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 88);

/**
 * @generated from message tempus.v1.ListDueReviewsRequest
 */
export type ListDueReviewsRequest = Message<"tempus.v1.ListDueReviewsRequest"> & {
  /**
   * Maximum number of due cards to return (0 = no limit).
   *
   * @generated from field: int32 limit = 1;
   */
  limit: number;
};

/**
 * Describes the message tempus.v1.ListDueReviewsRequest.
 * Use `create(ListDueReviewsRequestSchema)` to create a new message.
 */
export const ListDueReviewsRequestSchema: GenMessage<ListDueReviewsRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 89);

/**
 * @generated from message tempus.v1.ListDueReviewsResponse
 */
export type ListDueReviewsResponse = Message<"tempus.v1.ListDueReviewsResponse"> & {
  /**
   * @generated from field: repeated tempus.v1.SrsCard cards = 1;
   */
  cards: SrsCard[];

  /**
   * Total number of due cards (may exceed the returned count when limited).
   *
   * @generated from field: int32 total_due = 2;
   */
  totalDue: number;
};

/**
 * Describes the message tempus.v1.ListDueReviewsResponse.
 * Use `create(ListDueReviewsResponseSchema)` to create a new message.
 */
export const ListDueReviewsResponseSchema: GenMessage<ListDueReviewsResponse> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 90);

/**
 * @generated from message tempus.v1.UpdateCardRequest
 */
export type UpdateCardRequest = Message<"tempus.v1.UpdateCardRequest"> & {
  /**
   * @generated from field: int32 exercise_id = 1;
   */
  exerciseId: number;

  /**
   * @generated from field: tempus.v1.SrsCard card = 2;
   */
  card?: SrsCard | undefined;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 3;
   */
  updateMask?: FieldMask | undefined;
};

/**
 * Describes the message tempus.v1.UpdateCardRequest.
 * Use `create(UpdateCardRequestSchema)` to create a new message.
 */
export const UpdateCardRequestSchema: GenMessage<UpdateCardRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 91);

/**
 * ReviewState is an immutable snapshot of a card and its BPM frontier at the
 * moment a Review event was recorded.
 *
 * @generated from message tempus.v1.ReviewState
 */
export type ReviewState = Message<"tempus.v1.ReviewState"> & {
  /**
   * @generated from field: double ease_factor = 1;
   */
  easeFactor: number;

  /**
   * @generated from field: double interval_days = 2;
   */
  intervalDays: number;

  /**
   * @generated from field: int32 repetitions = 3;
   */
  repetitions: number;

  /**
   * @generated from field: google.protobuf.Timestamp due_date = 4;
   */
  dueDate?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp last_reviewed = 5;
   */
  lastReviewed?: Timestamp | undefined;

  /**
   * @generated from field: int32 mastered_bpm = 6;
   */
  masteredBpm: number;

  /**
   * @generated from field: int32 target_bpm = 7;
   */
  targetBpm: number;

  /**
   * @generated from field: int32 bpm_step = 8;
   */
  bpmStep: number;
};

/**
 * Describes the message tempus.v1.ReviewState.
 * Use `create(ReviewStateSchema)` to create a new message.
 */
export const ReviewStateSchema: GenMessage<ReviewState> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 92);

/**
 * ReviewEvent explains how and why an exercise's schedule changed.
 *
 * @generated from message tempus.v1.ReviewEvent
 */
export type ReviewEvent = Message<"tempus.v1.ReviewEvent"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: int32 exercise_id = 2;
   */
  exerciseId: number;

  /**
   * @generated from field: string event_type = 3;
   */
  eventType: string;

  /**
   * @generated from field: google.protobuf.Timestamp occurred_at = 4;
   */
  occurredAt?: Timestamp | undefined;

  /**
   * @generated from field: repeated int32 bpms = 5;
   */
  bpms: number[];

  /**
   * @generated from field: int32 rating = 6;
   */
  rating: number;

  /**
   * @generated from field: int32 quality = 7;
   */
  quality: number;

  /**
   * @generated from field: string summary = 8;
   */
  summary: string;

  /**
   * @generated from field: tempus.v1.ReviewState previous_state = 9;
   */
  previousState?: ReviewState | undefined;

  /**
   * @generated from field: tempus.v1.ReviewState resulting_state = 10;
   */
  resultingState?: ReviewState | undefined;

  /**
   * @generated from field: tempus.v1.Exercise exercise = 11;
   */
  exercise?: Exercise | undefined;
};

/**
 * Describes the message tempus.v1.ReviewEvent.
 * Use `create(ReviewEventSchema)` to create a new message.
 */
export const ReviewEventSchema: GenMessage<ReviewEvent> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 93);

/**
 * @generated from message tempus.v1.ListReviewEventsRequest
 */
export type ListReviewEventsRequest = Message<"tempus.v1.ListReviewEventsRequest"> & {
  /**
   * @generated from field: int32 exercise_id = 1;
   */
  exerciseId: number;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit: number;
};

/**
 * Describes the message tempus.v1.ListReviewEventsRequest.
 * Use `create(ListReviewEventsRequestSchema)` to create a new message.
 */
export const ListReviewEventsRequestSchema: GenMessage<ListReviewEventsRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 94);

/**
 * @generated from message tempus.v1.ListReviewEventsResponse
 */
export type ListReviewEventsResponse = Message<"tempus.v1.ListReviewEventsResponse"> & {
  /**
   * @generated from field: repeated tempus.v1.ReviewEvent events = 1;
   */
  events: ReviewEvent[];
};

/**
 * Describes the message tempus.v1.ListReviewEventsResponse.
 * Use `create(ListReviewEventsResponseSchema)` to create a new message.
 */
export const ListReviewEventsResponseSchema: GenMessage<ListReviewEventsResponse> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 95);

/**
 * User represents an authenticated account.
 *
 * @generated from message tempus.v1.User
 */
export type User = Message<"tempus.v1.User"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp | undefined;
};

/**
 * Describes the message tempus.v1.User.
 * Use `create(UserSchema)` to create a new message.
 */
export const UserSchema: GenMessage<User> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 96);

/**
 * @generated from message tempus.v1.SignupRequest
 */
export type SignupRequest = Message<"tempus.v1.SignupRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * @generated from field: string password = 2;
   */
  password: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * Invitation code; must match the server's configured SIGNUP_INVITE_CODE.
   *
   * @generated from field: string invite_code = 4;
   */
  inviteCode: string;
};

/**
 * Describes the message tempus.v1.SignupRequest.
 * Use `create(SignupRequestSchema)` to create a new message.
 */
export const SignupRequestSchema: GenMessage<SignupRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 97);

/**
 * @generated from message tempus.v1.LoginRequest
 */
export type LoginRequest = Message<"tempus.v1.LoginRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * @generated from field: string password = 2;
   */
  password: string;
};

/**
 * Describes the message tempus.v1.LoginRequest.
 * Use `create(LoginRequestSchema)` to create a new message.
 */
export const LoginRequestSchema: GenMessage<LoginRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 98);

/**
 * @generated from message tempus.v1.LogoutRequest
 */
export type LogoutRequest = Message<"tempus.v1.LogoutRequest"> & {
};

/**
 * Describes the message tempus.v1.LogoutRequest.
 * Use `create(LogoutRequestSchema)` to create a new message.
 */
export const LogoutRequestSchema: GenMessage<LogoutRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 99);

/**
 * @generated from message tempus.v1.MeRequest
 */
export type MeRequest = Message<"tempus.v1.MeRequest"> & {
};

/**
 * Describes the message tempus.v1.MeRequest.
 * Use `create(MeRequestSchema)` to create a new message.
 */
export const MeRequestSchema: GenMessage<MeRequest> = /*@__PURE__*/
  messageDesc(file_tempus_v1_tempus, 100);

/**
 * @generated from service tempus.v1.CategoryService
 */
export const CategoryService: GenService<{
  /**
   * Create a new category
   *
   * @generated from rpc tempus.v1.CategoryService.CreateCategory
   */
  createCategory: {
    methodKind: "unary";
    input: typeof CreateCategoryRequestSchema;
    output: typeof CategorySchema;
  },
  /**
   * Get a category by ID
   *
   * @generated from rpc tempus.v1.CategoryService.GetCategory
   */
  getCategory: {
    methodKind: "unary";
    input: typeof GetCategoryRequestSchema;
    output: typeof CategorySchema;
  },
  /**
   * List categories with optional pagination
   *
   * @generated from rpc tempus.v1.CategoryService.ListCategories
   */
  listCategories: {
    methodKind: "unary";
    input: typeof ListCategoriesRequestSchema;
    output: typeof ListCategoriesResponseSchema;
  },
  /**
   * Update a category
   *
   * @generated from rpc tempus.v1.CategoryService.UpdateCategory
   */
  updateCategory: {
    methodKind: "unary";
    input: typeof UpdateCategoryRequestSchema;
    output: typeof CategorySchema;
  },
  /**
   * Delete a category
   *
   * @generated from rpc tempus.v1.CategoryService.DeleteCategory
   */
  deleteCategory: {
    methodKind: "unary";
    input: typeof DeleteCategoryRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_tempus_v1_tempus, 0);

/**
 * @generated from service tempus.v1.TagService
 */
export const TagService: GenService<{
  /**
   * Create a new tag
   *
   * @generated from rpc tempus.v1.TagService.CreateTag
   */
  createTag: {
    methodKind: "unary";
    input: typeof CreateTagRequestSchema;
    output: typeof TagSchema;
  },
  /**
   * Get a tag by ID
   *
   * @generated from rpc tempus.v1.TagService.GetTag
   */
  getTag: {
    methodKind: "unary";
    input: typeof GetTagRequestSchema;
    output: typeof TagSchema;
  },
  /**
   * List tags with optional pagination and filtering
   *
   * @generated from rpc tempus.v1.TagService.ListTags
   */
  listTags: {
    methodKind: "unary";
    input: typeof ListTagsRequestSchema;
    output: typeof ListTagsResponseSchema;
  },
  /**
   * Update a tag
   *
   * @generated from rpc tempus.v1.TagService.UpdateTag
   */
  updateTag: {
    methodKind: "unary";
    input: typeof UpdateTagRequestSchema;
    output: typeof TagSchema;
  },
  /**
   * Delete a tag
   *
   * @generated from rpc tempus.v1.TagService.DeleteTag
   */
  deleteTag: {
    methodKind: "unary";
    input: typeof DeleteTagRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_tempus_v1_tempus, 1);

/**
 * @generated from service tempus.v1.ExerciseService
 */
export const ExerciseService: GenService<{
  /**
   * Create a new exercise
   *
   * @generated from rpc tempus.v1.ExerciseService.CreateExercise
   */
  createExercise: {
    methodKind: "unary";
    input: typeof CreateExerciseRequestSchema;
    output: typeof ExerciseSchema;
  },
  /**
   * Get an exercise by ID
   *
   * @generated from rpc tempus.v1.ExerciseService.GetExercise
   */
  getExercise: {
    methodKind: "unary";
    input: typeof GetExerciseRequestSchema;
    output: typeof ExerciseSchema;
  },
  /**
   * List exercises with optional pagination and filtering
   *
   * @generated from rpc tempus.v1.ExerciseService.ListExercises
   */
  listExercises: {
    methodKind: "unary";
    input: typeof ListExercisesRequestSchema;
    output: typeof ListExercisesResponseSchema;
  },
  /**
   * Update an exercise
   *
   * @generated from rpc tempus.v1.ExerciseService.UpdateExercise
   */
  updateExercise: {
    methodKind: "unary";
    input: typeof UpdateExerciseRequestSchema;
    output: typeof ExerciseSchema;
  },
  /**
   * Delete an exercise
   *
   * @generated from rpc tempus.v1.ExerciseService.DeleteExercise
   */
  deleteExercise: {
    methodKind: "unary";
    input: typeof DeleteExerciseRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Add an image to an exercise
   *
   * @generated from rpc tempus.v1.ExerciseService.AddExerciseImage
   */
  addExerciseImage: {
    methodKind: "unary";
    input: typeof AddExerciseImageRequestSchema;
    output: typeof ExerciseImageSchema;
  },
  /**
   * @generated from rpc tempus.v1.ExerciseService.GetExerciseImage
   */
  getExerciseImage: {
    methodKind: "unary";
    input: typeof GetExerciseImageRequestSchema;
    output: typeof ExerciseImageSchema;
  },
  /**
   * Update an image's annotation (description text and/or variation tie-back)
   *
   * @generated from rpc tempus.v1.ExerciseService.UpdateExerciseImage
   */
  updateExerciseImage: {
    methodKind: "unary";
    input: typeof UpdateExerciseImageRequestSchema;
    output: typeof ExerciseImageSchema;
  },
  /**
   * Delete an image from an exercise
   *
   * @generated from rpc tempus.v1.ExerciseService.DeleteExerciseImage
   */
  deleteExerciseImage: {
    methodKind: "unary";
    input: typeof DeleteExerciseImageRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Add a link to an exercise
   *
   * @generated from rpc tempus.v1.ExerciseService.AddExerciseLink
   */
  addExerciseLink: {
    methodKind: "unary";
    input: typeof AddExerciseLinkRequestSchema;
    output: typeof ExerciseLinkSchema;
  },
  /**
   * Delete a link from an exercise
   *
   * @generated from rpc tempus.v1.ExerciseService.DeleteExerciseLink
   */
  deleteExerciseLink: {
    methodKind: "unary";
    input: typeof DeleteExerciseLinkRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Get statistics for an exercise
   *
   * @generated from rpc tempus.v1.ExerciseService.GetExerciseStats
   */
  getExerciseStats: {
    methodKind: "unary";
    input: typeof GetExerciseStatsRequestSchema;
    output: typeof ExerciseStatsSchema;
  },
  /**
   * Create a variation of an exercise
   *
   * @generated from rpc tempus.v1.ExerciseService.CreateVariation
   */
  createVariation: {
    methodKind: "unary";
    input: typeof CreateVariationRequestSchema;
    output: typeof ExerciseSchema;
  },
  /**
   * List variations of an exercise
   *
   * @generated from rpc tempus.v1.ExerciseService.ListVariations
   */
  listVariations: {
    methodKind: "unary";
    input: typeof ListVariationsRequestSchema;
    output: typeof ListVariationsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_tempus_v1_tempus, 2);

/**
 * @generated from service tempus.v1.PracticeSessionService
 */
export const PracticeSessionService: GenService<{
  /**
   * Create a new practice session
   *
   * @generated from rpc tempus.v1.PracticeSessionService.CreatePracticeSession
   */
  createPracticeSession: {
    methodKind: "unary";
    input: typeof CreatePracticeSessionRequestSchema;
    output: typeof PracticeSessionSchema;
  },
  /**
   * Get a practice session by ID
   *
   * @generated from rpc tempus.v1.PracticeSessionService.GetPracticeSession
   */
  getPracticeSession: {
    methodKind: "unary";
    input: typeof GetPracticeSessionRequestSchema;
    output: typeof PracticeSessionSchema;
  },
  /**
   * List practice sessions with optional pagination and filtering
   *
   * @generated from rpc tempus.v1.PracticeSessionService.ListPracticeSessions
   */
  listPracticeSessions: {
    methodKind: "unary";
    input: typeof ListPracticeSessionsRequestSchema;
    output: typeof ListPracticeSessionsResponseSchema;
  },
  /**
   * Update a practice session
   *
   * @generated from rpc tempus.v1.PracticeSessionService.UpdatePracticeSession
   */
  updatePracticeSession: {
    methodKind: "unary";
    input: typeof UpdatePracticeSessionRequestSchema;
    output: typeof PracticeSessionSchema;
  },
  /**
   * Delete a practice session
   *
   * @generated from rpc tempus.v1.PracticeSessionService.DeletePracticeSession
   */
  deletePracticeSession: {
    methodKind: "unary";
    input: typeof DeletePracticeSessionRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Get practice statistics
   *
   * @generated from rpc tempus.v1.PracticeSessionService.GetPracticeStats
   */
  getPracticeStats: {
    methodKind: "unary";
    input: typeof GetPracticeStatsRequestSchema;
    output: typeof PracticeStatsSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_tempus_v1_tempus, 3);

/**
 * @generated from service tempus.v1.ExerciseHistoryService
 */
export const ExerciseHistoryService: GenService<{
  /**
   * Create a new exercise history entry
   *
   * @generated from rpc tempus.v1.ExerciseHistoryService.CreateExerciseHistory
   */
  createExerciseHistory: {
    methodKind: "unary";
    input: typeof CreateExerciseHistoryRequestSchema;
    output: typeof ExerciseHistorySchema;
  },
  /**
   * Get an exercise history entry by ID
   *
   * @generated from rpc tempus.v1.ExerciseHistoryService.GetExerciseHistory
   */
  getExerciseHistory: {
    methodKind: "unary";
    input: typeof GetExerciseHistoryRequestSchema;
    output: typeof ExerciseHistorySchema;
  },
  /**
   * List exercise history entries with optional pagination and filtering
   *
   * @generated from rpc tempus.v1.ExerciseHistoryService.ListExerciseHistory
   */
  listExerciseHistory: {
    methodKind: "unary";
    input: typeof ListExerciseHistoryRequestSchema;
    output: typeof ListExerciseHistoryResponseSchema;
  },
  /**
   * Update an exercise history entry
   *
   * @generated from rpc tempus.v1.ExerciseHistoryService.UpdateExerciseHistory
   */
  updateExerciseHistory: {
    methodKind: "unary";
    input: typeof UpdateExerciseHistoryRequestSchema;
    output: typeof ExerciseHistorySchema;
  },
  /**
   * Delete an exercise history entry
   *
   * @generated from rpc tempus.v1.ExerciseHistoryService.DeleteExerciseHistory
   */
  deleteExerciseHistory: {
    methodKind: "unary";
    input: typeof DeleteExerciseHistoryRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_tempus_v1_tempus, 4);

/**
 * @generated from service tempus.v1.NewBreedService
 */
export const NewBreedService: GenService<{
  /**
   * List all systems (reference data)
   *
   * @generated from rpc tempus.v1.NewBreedService.ListSystems
   */
  listSystems: {
    methodKind: "unary";
    input: typeof ListSystemsRequestSchema;
    output: typeof ListSystemsResponseSchema;
  },
  /**
   * List all melody pages with their melodies (reference data)
   *
   * @generated from rpc tempus.v1.NewBreedService.ListMelodyPages
   */
  listMelodyPages: {
    methodKind: "unary";
    input: typeof ListMelodyPagesRequestSchema;
    output: typeof ListMelodyPagesResponseSchema;
  },
  /**
   * Create a practice entry
   *
   * @generated from rpc tempus.v1.NewBreedService.CreatePracticeEntry
   */
  createPracticeEntry: {
    methodKind: "unary";
    input: typeof CreatePracticeEntryRequestSchema;
    output: typeof NewBreedPracticeEntrySchema;
  },
  /**
   * Get a practice entry by ID
   *
   * @generated from rpc tempus.v1.NewBreedService.GetPracticeEntry
   */
  getPracticeEntry: {
    methodKind: "unary";
    input: typeof GetPracticeEntryRequestSchema;
    output: typeof NewBreedPracticeEntrySchema;
  },
  /**
   * List practice entries with optional filters
   *
   * @generated from rpc tempus.v1.NewBreedService.ListPracticeEntries
   */
  listPracticeEntries: {
    methodKind: "unary";
    input: typeof ListPracticeEntriesRequestSchema;
    output: typeof ListPracticeEntriesResponseSchema;
  },
  /**
   * Update a practice entry
   *
   * @generated from rpc tempus.v1.NewBreedService.UpdatePracticeEntry
   */
  updatePracticeEntry: {
    methodKind: "unary";
    input: typeof UpdatePracticeEntryRequestSchema;
    output: typeof NewBreedPracticeEntrySchema;
  },
  /**
   * Delete a practice entry
   *
   * @generated from rpc tempus.v1.NewBreedService.DeletePracticeEntry
   */
  deletePracticeEntry: {
    methodKind: "unary";
    input: typeof DeletePracticeEntryRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Get the practice matrix (aggregated progress for all system+page combos)
   *
   * @generated from rpc tempus.v1.NewBreedService.GetMatrix
   */
  getMatrix: {
    methodKind: "unary";
    input: typeof GetMatrixRequestSchema;
    output: typeof GetMatrixResponseSchema;
  },
  /**
   * Get detailed progress for a single system
   *
   * @generated from rpc tempus.v1.NewBreedService.GetSystemProgress
   */
  getSystemProgress: {
    methodKind: "unary";
    input: typeof GetSystemProgressRequestSchema;
    output: typeof GetSystemProgressResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_tempus_v1_tempus, 5);

/**
 * SettingsService manages application settings (key-value pairs).
 *
 * @generated from service tempus.v1.SettingsService
 */
export const SettingsService: GenService<{
  /**
   * Get a single setting by key
   *
   * @generated from rpc tempus.v1.SettingsService.GetSetting
   */
  getSetting: {
    methodKind: "unary";
    input: typeof GetSettingRequestSchema;
    output: typeof GetSettingResponseSchema;
  },
  /**
   * Set a setting value (creates or updates)
   *
   * @generated from rpc tempus.v1.SettingsService.SetSetting
   */
  setSetting: {
    methodKind: "unary";
    input: typeof SetSettingRequestSchema;
    output: typeof SetSettingResponseSchema;
  },
  /**
   * List all settings
   *
   * @generated from rpc tempus.v1.SettingsService.ListSettings
   */
  listSettings: {
    methodKind: "unary";
    input: typeof ListSettingsRequestSchema;
    output: typeof ListSettingsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_tempus_v1_tempus, 6);

/**
 * SrsService manages Tempus's spaced-repetition Review system. Reviews
 * are graded automatically: when an ExerciseHistory entry is recorded for an
 * enrolled exercise, its card is rescheduled from the logged BPMs (and rating,
 * when present). See server/handlers/srs.go for the SM-2 + BPM-ladder logic.
 *
 * @generated from service tempus.v1.SrsService
 */
export const SrsService: GenService<{
  /**
   * Enroll an exercise in Review (creates a card).
   *
   * @generated from rpc tempus.v1.SrsService.EnrollExercise
   */
  enrollExercise: {
    methodKind: "unary";
    input: typeof EnrollExerciseRequestSchema;
    output: typeof SrsCardSchema;
  },
  /**
   * Remove an exercise from Review (deletes its card).
   *
   * @generated from rpc tempus.v1.SrsService.UnenrollExercise
   */
  unenrollExercise: {
    methodKind: "unary";
    input: typeof UnenrollExerciseRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Get the card for a single exercise.
   *
   * @generated from rpc tempus.v1.SrsService.GetCard
   */
  getCard: {
    methodKind: "unary";
    input: typeof GetCardRequestSchema;
    output: typeof SrsCardSchema;
  },
  /**
   * List all enrolled cards, optionally only those that are due.
   *
   * @generated from rpc tempus.v1.SrsService.ListCards
   */
  listCards: {
    methodKind: "unary";
    input: typeof ListCardsRequestSchema;
    output: typeof ListCardsResponseSchema;
  },
  /**
   * List cards that are due for review, most overdue first.
   *
   * @generated from rpc tempus.v1.SrsService.ListDueReviews
   */
  listDueReviews: {
    methodKind: "unary";
    input: typeof ListDueReviewsRequestSchema;
    output: typeof ListDueReviewsResponseSchema;
  },
  /**
   * Manually adjust a card's BPM ladder or scheduling parameters.
   *
   * @generated from rpc tempus.v1.SrsService.UpdateCard
   */
  updateCard: {
    methodKind: "unary";
    input: typeof UpdateCardRequestSchema;
    output: typeof SrsCardSchema;
  },
  /**
   * List immutable schedule-change events, newest first.
   *
   * @generated from rpc tempus.v1.SrsService.ListReviewEvents
   */
  listReviewEvents: {
    methodKind: "unary";
    input: typeof ListReviewEventsRequestSchema;
    output: typeof ListReviewEventsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_tempus_v1_tempus, 7);

/**
 * AuthService handles signup, login, logout, and the current-user lookup.
 * Sessions are delivered as an httpOnly cookie set on the Login/Signup
 * responses, so clients never handle the session token directly.
 *
 * @generated from service tempus.v1.AuthService
 */
export const AuthService: GenService<{
  /**
   * Create a new account (requires a valid invite code) and start a session.
   *
   * @generated from rpc tempus.v1.AuthService.Signup
   */
  signup: {
    methodKind: "unary";
    input: typeof SignupRequestSchema;
    output: typeof UserSchema;
  },
  /**
   * Authenticate with email + password and start a session.
   *
   * @generated from rpc tempus.v1.AuthService.Login
   */
  login: {
    methodKind: "unary";
    input: typeof LoginRequestSchema;
    output: typeof UserSchema;
  },
  /**
   * End the current session.
   *
   * @generated from rpc tempus.v1.AuthService.Logout
   */
  logout: {
    methodKind: "unary";
    input: typeof LogoutRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Return the currently authenticated user (Unauthenticated if no session).
   *
   * @generated from rpc tempus.v1.AuthService.Me
   */
  me: {
    methodKind: "unary";
    input: typeof MeRequestSchema;
    output: typeof UserSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_tempus_v1_tempus, 8);

